"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/axios";
import { useCountry, useCity, useUserRole, useAddedFare, useStateStore } from "@/store/common";
import { MESSAGES } from "@/constants/messages";
import { toast } from "react-toastify";
import { useAuth } from "@/store/auth";

type PersonalInfoRequest = {
  father_name: string;
  alternate_email: string;
  alternate_mobile: string;
  dob: string;
  gender: string;
  address: string;
  pincode: string;
  mobile: string;
  email: string;
  typeId: string;
  signup_status?: string;
};
interface UserProfilePayload {
  id: string;
  [key: string]: any;
}
type CompanyInfoRequest = {
  company_name?: string;
  company_address?: string;
  city_id?: string;
  pincode?: string;
  service_tax_gst?: string;
  pancard_no?: string;
  contact_person_name?: string;
  landline_no?: string;
  mobile_no?: string;
  email?: string;
  website_url: string;
  // logo: string,
  // gst_file: string,
  // pan_file: string,
  user_email?: string;
  user_mobile?: string;
  typeId: string;
  id?: string | number;
};
type userProfileUpdateRequest = {
  first_name: string;
  last_name: string;
  father_name: string;
  alternate_mobile: string;
  external_ref: string;
  gender: string;
  address: string;
  pincode: string;
  kyc_type: string;
  kyc: string;
  newsletter_subscription: boolean;
  landline_number: string;
};

export type User = {
  id: string;
  name: string;
  email: string;
  mobile: string;
  country: string;
  city_name: string;
  userStatus: string;
  signupStatus: string;
  first_name?: string;
  last_name?: string;
  login_status: boolean;
  isActive: boolean;
  logout_time?: string;
  pending_doc?: string;
  user_type: string;
};

type Pagination = {
  totalPages: number;
  totalItems?: number;
  currentPage?: number;
};

type UserResponse = {
  users: User[];
  pagination: Pagination;
  data?: any;
};
type addCabForm = {
  vehicle_name: string;
  ignition_type: string;
  vehicle_color: string;
  carrier?: string;
  ac?: string;
  owner?: string;
  permit_expiry_date?: string;
  model_year?: string;
  vehicle_code?: string;
  vehicle_reg_no?: string;
  insurance_validity?: string;
  fitness_validity?: string;
  passenger: number;
  big_suitcase: number;
  small_suitcase: number;
  amenities?: string;
  owner_name?: string;
  reg_date?: string;
  chassis_no?: string;
  engine_no?: string;
  insurance_name?: string;
  policy_number?: string;
  policy_issue?: string;
  premium_amount?: string;
  cover_amount?: string;
  rto_address?: string;
  rto_tax_efficiency?: string;
  rto_expiry?: string;
  fitness_number?: string;
  fitness_expiry?: string;
  auth_number?: string;
  auth_expiry?: string;
  speed_governor_detail?: string;
  speed_governor_expiry?: string;
  puc_number?: string;
  puc_expiry?: string;
  permit_type?: string;
  permit_expiry?: string;
  vehicle_name_id?: string;
  amenties_id?: string;
  vmId?: string;
  user_email?: string;
  user_mobile?: string;
  typeId?: string;
};

interface CancelBookingPayload {
  client_wallet_amount: number;
  user_id: number;
  itinerary_id: number;
  booking_id: number;
  created_by: number;
  cancellationCharges: number;
  estimated_final_price: number;
  status: any;
  ip: string;
  driver_id: number;
  reason: string;
  type: string;
}

interface UpdateBookingPayload {
  booking_id: number;
  status_c: any;
  updated_on: any;
}

//
type ReDispatchPayload = {
  user_id: number;
  itinerary_id: number;
  booking_id: number;
  driver_id: number;
  reason_text: string;
  remark_text: string;
  booking_status: any;
  mobile_no: any;
  booking_ref: any;
  pick_lat: string;
  pick_long: string;
};

type BookingListPayload = {
  id: string;
  driver_id: string;
  [key: string]: any;
};

type BookingListResponse = any;

type CompanyDetailResponse = any;

type UpdateUserStatusPayload = {
  id: number | string;
  userId: number | string;
  userStatus: number;
};

type CompanyDetailsPayload = {
  company_id: number | string;
};

interface ReDispatchPayloadFilter {
  from_time?: string;
  to_time?: string;
  from_date?: string;
  to_date?: string;
  pickup_time?: string;
  unassignedbooking?: boolean;
  user_mobile?: string;
  multi_vehicle_type?: string[];
  multi_city_name?: string[];

  booking_id?: string;
  booking_type?: string;
  driver_first_name?: string;
  driver_last_name?: string;
  driver_id?: string;
  referral_key?: string;
  driver_email?: string;
  driver_mobile_no?: string;
  client_first_name?: string;
  client_last_name?: string;
  client_id?: string;
  client_email?: string;
  client_mobile_no?: string;
  vehicle_type?: string;
  vehicle_no?: string;
  state_name?: string;
  city_name?: string;
  pickupaddress?: string;
  drop_area?: string;
  booking_status?: string;
  payment_type?: string;
  status?: string;
  partner_name?: string;
  created_by?: string;

  package_mode?: string;
  coupon_code?: string;
  vehicle_model?: string;
  company_name?: string;
  user_nationality?: string;
  currency?: string;
  transaction_type?: string;
  min_amount?: number;
  max_amount?: number;
  is_roundtrip?: boolean;
  is_corporate?: boolean;
  is_recurring?: boolean;
}
type ClientBookingPayload = {
  type: "booking";
  clientInfo: {
    client_mobile: string;
    clientname: string;
    ordertime: string;
    estimated_final_price: string;
  };
  post: {
    booking_id: string;
  };
};

type ClientDriverPayload = {
  type: "driver";
  clientInfo: {
    mobile: string;
    driver_name: string;
    ordertime: string;
    estimated_final_price: string;
  };
  post: {
    booking_id: string;
  };
};

type SendMessagePayload = ClientBookingPayload | ClientDriverPayload;

type ExecuteNoShowPayload = {
  booking_status: string;
  driver_id: number;
  user_id: number;
  mobile_no: string;
  booking_ref: string;
  reason_text?: string;
  remark_text?: string;
  booking_id: number;
};

type GetMarkupPayload = Partial<{
  company_id: any;
  country_id: any;
  city_id: any;
  markup_type: any;
  master_package_id: any;
  user_id: any;
  user_grade: any;
  markup_id: any;
  created_by: any;
  master_booking_type_id: any;
  state_id: any;
  markup_category: any;
  page: number;
  pageSize: number;
}>;

type GetMarkupLogsPayload = Partial<{
  markup_id: any;
}>;

//updateMarkupPayload
type updateMarkupPayload = Partial<{
  id: string;
  user_id: string;
  markup_status: number;
}>;

export type updateMarkupPayloadAdd = {
  id: number | string;
  user_id: number | string;
  markup_status: string;

  company_id: number | string;
  master_booking_type_id: number | string;
  user_grade: string;
  markup_category: string;
  country_id: number | string;
  state_id: number | string;
  city_id: number | string;
  currency: string;
  master_package_id: number | string;
  vehicle_type_id: number | string;
  markup_amt_type: string;
  markup_amount: number;
  markup_amt_base: string;
  extra_km: number;
  extra_min: number;
  created_by: number | string;
  ip: string;
};

type BookingCountPayload = {
  date: any;
};

type BookingItenaryResponse = {
  itineraryid: string;
};

export const useGetCityDataMutation = () => {
  const { setCityData } = useCity();
  return useMutation({
    mutationFn: (city: string) => api.post("/cities/city-name", { city }),
    onSuccess: (res) => {
      const cityData = res?.data?.data;
      setCityData(cityData);
    },
    onError: (err) => {
      console.error(MESSAGES.FAILED_FETCHED, err);
    },
  });
};

export const useGetCountryDataMutation = () => {
  const { setCountryData } = useCountry();
  return useMutation({
    mutationFn: (country: string) =>
      api.post("/cities/country-name", { country }),
    onSuccess: (res) => {
      const countryData = res?.data?.data;
      setCountryData(countryData);
    },
    onError: (err) => {
      console.error(MESSAGES.FAILED_FETCHED, err);
    },
  });
};

export const useGetStateDataMutation = () => {
  const { setStateData } = useStateStore();
  return useMutation({
    mutationFn: (state: string) => api.post("/city/get-states-by-name", { state_name: state }),
    onSuccess: (res) => {
      const stateData = res?.data?.responseData?.response?.data || [];
      setStateData(stateData);
      return stateData;
    },
    onError: (err) => {
      console.error("Failed to fetch states:", err);
      return [];
    },
  });
};

export const usePersonalInfo = () => {
  return useMutation({
    mutationFn: (body: PersonalInfoRequest) =>
      api.post("/user/personal-info", {
        ...body,
      }),
    onSuccess: (res) => {
      return true;
    },
  });
};

export const useCompanyInfo = () => {
  return useMutation({
    mutationFn: (body: any) => api.post("/company/company-info", body, {}),
    onSuccess: (res) => {
      const companyData = res?.data?.responseData?.response?.data?.countryData;
    },
  });
};

// export const useGetCompanyDetailsById = (id: number) => {
//   return useQuery({
//     queryKey: ['companyDetails',id],
//     queryFn: async() => {
//       const res = await api.get(`/company/get/${id}`);
//       console.log(res);
//       return res;
//     },
//     enabled: !!id
//   })
// }

export const useGetUserProfileInfo = (id: number) => {
  return useQuery({
    queryKey: ["userProfile", id],
    queryFn: async () => {
      const res = await api.get(`/user/${id}`);
      // Return dataValues if it exists, otherwise return the user object directly
      const user = res?.data?.responseData?.response?.data?.user;
      return user?.dataValues || user;
    },
    enabled: !!id && id > 0,
  });
};
export const useUpdateUserProfilePhoto = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ file, folder }: { file: File; folder: string }) => {
      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post(
        `/user/${id}/photo?folder=${encodeURIComponent(folder)}`,
        formData
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["userProfile", id] });
    },
  });
};

export const useUpdateUserDoc = (
  id: number,
  onSuccessCallback?: (doc: any) => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      file,
      folder,
      doc_type_id,
      user_id,
    }: {
      file: File;
      folder: string;
      doc_type_id: string;
      user_id: string;
    }) => {
      const formData = new FormData();
      formData.append("file", file);
      // formData.append("folder", folder);
      formData.append("doc_type_id", doc_type_id);
      formData.append("user_id", user_id);
      const res = await api.post(
        `/user/user-documents?folder=${encodeURIComponent(folder)}`,
        formData
      );

      return res?.data?.responseData?.response?.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["userDocProfile", id] });
      if (onSuccessCallback) {
        onSuccessCallback(data?.userDocuments);
      }
    },
  });
};

export const useUpdateVehicleDoc = (
  id: number,
  onSuccessCallback?: (doc: any) => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      file,
      folder,
      doc_type_id,
      user_id,
      vehicle_id,
    }: {
      file: File;
      folder: string;
      doc_type_id: string;
      user_id: string;
      vehicle_id: string;
    }) => {
      const formData = new FormData();
      formData.append("file", file);
      // formData.append("folder", folder);
      formData.append("document_type_id", doc_type_id);
      formData.append("user_id", user_id);
      formData.append("vehicle_id", vehicle_id);
      // const res = await api.post(
      //   `/user/user-documents?folder=${encodeURIComponent(folder)}`,
      //   formData
      // );
      const res = await api.post(
        `/userVehicleDocument?folder=${encodeURIComponent(folder)}`,
        formData
      );
      return res?.data?.responseData?.response?.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["userDocProfile", id] });
      if (onSuccessCallback) {
        onSuccessCallback(data?.userDocuments);
      }
    },
  });
};

export const useUpateUserProfile = () => {
  return useMutation({
    mutationFn: (body: userProfileUpdateRequest) =>
      api.put("/user/profile", body, {}),
    onSuccess: (res) => {
      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};

export const useGetUserKycList = (doc_level_name: string) => {
  return useQuery({
    queryKey: ["doc_level_List", doc_level_name],
    queryFn: async () => {
      const res = await api.get(`/user/documents-list/${doc_level_name}`);
      return res?.data?.responseData?.response?.data?.documentData;
    },
    enabled: !!doc_level_name,
  });
};

export const useGetAllUser = (
  page: number,
  limit: number = 20,
  filters: Record<string, any> = {},
  enabled: boolean = true
) => {
  const { user } = useAuth();
  const cleanFilters = Object.fromEntries(
    Object.entries(filters).filter(([_, v]) => v !== undefined && v !== "")
  );

  return useQuery<UserResponse, Error>({
    queryKey: ["allUser", page, limit, cleanFilters],
    queryFn: async () => {
      const res = await api.get("/user", {
        params: {
          page,
          limit,
          ...cleanFilters,
        },
      });
      return res?.data?.responseData?.response;
    },
    enabled: enabled && !!user?.id, // Only fetch if user is authenticated
  });
};

export const useGetUserCreditTrancations = () => {
  return useMutation({
    mutationFn: async (body: { company_id?: number; user_id?: number }) => {
      const res = await api.post("/creditLimit/", body, {});
      return res?.data?.responseData?.response?.data?.allUserCreditLimit;
    },
  });
};
export const useGetUserWalletBalance = () => {
  return useQuery({
    queryKey: ["wallet"],
    queryFn: async () => {
      const res = await api.get("/creditLimit/wallet");
      return (
        res?.data?.responseData?.response?.data?.result[0]?.credit_balance ?? 0
      );
    },
    enabled: true,
  });
};

export const useGetReferralPoints = () => {
  return useQuery({
    queryKey: ["referralPoint"],
    queryFn: async () => {
      const res = await api.get("/creditLimit/referal-points");
      return res?.data?.responseData?.response?.data;
    },
    enabled: true,
  });
};

export const useGetRecentUserDetails = () => {
  return useMutation({
    mutationFn: async (filters: {
      name?: string;
      user_id?: number;
      company_id?: number;
      isCommingFromb2bPanel?: boolean;
    }) => {
      const res = await api.post("/user/get-recent-user-detail", filters);
      return res?.data?.responseData?.response?.data.recentUserData;
    },
  });
};

export const useBiddingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      city_distance_id?: number;
      route_id?: number;
      driver_id?: number;
      source_city?: number;
      destination_city?: number;
      multi_vehicle_type?: string;
      from_date?: string;
      to_date?: string;
      user_id?: number;
      page?: number;
      limit?: number;
    }) => {
      const res = await api.post("/bidding/get-bidding", body, {});
      console.log("res", res.data?.data);
      return res?.data?.data;
    },
  });
};
// accept-job
export const useRecentBookingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      user_type_id?: number;
      user_id?: number;
      page?: number;
      limit?: number;
    }) => {
      const res = await api.post("/booking/recently-viewed", body, {});
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useAcceptedBookingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      user_type_id?: number;
      user_id?: number;
      page?: number;
      limit?: number;
    }) => {
      const res = await api.post("/driver/vendor-accept-job", body, {});
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useAssignedBookingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      user_type_id?: number;
      user_id?: number;
      page?: number;
      limit?: number;
      status?: 3;
    }) => {
      const res = await api.post("/booking/booking-list", body, {});
      return res?.data?.responseData?.response?.data?.data;
    },
  });
};
export const usefetchQuotation = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("booking/quotation-list/", body);
      return res.data;
    },
  });
};
export const useUnAssignedBookingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      draw: number;
      start: number;
      length: number;
      order: { column: number; dir: "asc" | "desc" }[];
      columns: { data: string }[];
      search: { value: string };
      user_type_id?: number;
      user_id?: number;
      // Add any other fields like vehicle_type_id, etc. if needed
    }) => {
      const res = await api.post("/booking/recently-unassigned-booking", body);
      return res?.data?.data;
    },
  });
};
export const deleteQuotation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post(
        "/booking/updateQuotationStatus",
        payload
      );
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetVehicleModels = (vehicle_type_id: number) => {
  return useQuery({
    queryKey: ["VehicleModels", vehicle_type_id],
    queryFn: async () => {
      const res = await api.get(`/vehicle/vehicle-model/${vehicle_type_id}`);
      return res?.data?.responseData?.response?.data;
    },
    enabled: !!vehicle_type_id,
  });
};
export const useGetVehicles = (params: any) => {
  return useQuery({
    queryKey: ["Vehicles", params],
    queryFn: async () => {
      const res = await api.get(`/vehicle/all`, {
        params: params,
      });

      return res?.data?.responseData?.response?.data;
    },
    enabled: !!params,
  });
};

export const useGetVehicletype = () => {
  return useQuery({
    queryKey: ["VehicleType"],
    queryFn: async () => {
      // This endpoint now uses optionalAuthenticate - works for both authenticated and guest users
      const res = await api.get(`/vehicle/vehicle-type`, {
        params: {
          page: 1,
          limit: 1000, // Get all vehicle types
        },
      });
      return res?.data?.responseData?.response?.data?.vehicleModelType;
    },
    enabled: true,
  });
};

export const useGetActiveDriverList = () => {
  return useQuery({
    queryKey: ["DriverList"],
    queryFn: async () => {
      const res = await api.get(`/driver/vehicle-details`);
      return res?.data?.responseData?.response?.data?.vehicleModelType;
    },
    enabled: true,
  });
};

type VendorAcceptJobResponse = {
  status: string;
  message: string;
};

export const useVendorAcceptedJob = () => {
  return useMutation<
    VendorAcceptJobResponse,
    Error,
    { booking_id: number; id: number }
  >({
    mutationFn: async (body) => {
      const res = await api.post("/driver/vendor-accept-job", body);
      return res?.data?.responseData?.response;
    },
  });
};

export const useGetTripDetails = (itineraryId: string) => {
  return useQuery({
    queryKey: ["Tripdetail", itineraryId],
    queryFn: async () => {
      const res = await api.get(`/booking/trip-details/${itineraryId}`);
      return res?.data?.responseData?.response?.data?.results[0];
    },
    enabled: !!itineraryId,
  });
};

export const useGetDriverClaimMutation = (
  user_id?: number,
  user_type_id?: number,
  type?: string
) => {
  const requestData: {
    user_id?: number;
    type?: string;
  } = {};

  if (user_type_id !== 10) {
    if (user_id) requestData.user_id = user_id;
    if (type) requestData.type = type;
  } else {
    if (type) requestData.type = type;
  }

  return useMutation({
    mutationFn: async (additionalBody: {
      master_package_id?: number;
      vehicle_type_id?: number;
      booking_amount?: number;
      city_id?: number;
    }) => {
      const body = {
        ...requestData,
        ...additionalBody,
      };

      const res = await api.post("/driver/claim-list", body);
      return res?.data?.responseData?.response?.data?.result;
    },
  });
};
export const useReserveBookingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      booking_id?: string | number;
      driver_id?: string | number;
    }) => {
      const res = await api.post("/booking/reserve-booking", body);
      return res?.data?.responseData?.response?.data?.result;
    },
  });
};

export const useDeleteRecentlyViewedMutation = (
  onSuccessCallback?: () => void
) => {
  return useMutation({
    mutationFn: async (body: { id: string | number }) => {
      const res = await api.delete("/booking/delete-recently-viewed", {
        data: body,
      });
      return res?.data?.responseData?.response?.data?.result;
    },
    onSuccess: () => {
      if (onSuccessCallback) onSuccessCallback();
    },
  });
};

export const useStatusRecentlyViewedMutation = (
  onSuccessCallback?: () => void
) => {
  return useMutation({
    mutationFn: async (body: {
      id: string | number;
      status: string | number;
    }) => {
      const res = await api.put("/booking/status-recently-viewed", body);
      return res?.data?.responseData?.response?.data?.result;
    },
    onSuccess: () => {
      if (onSuccessCallback) onSuccessCallback();
    },
  });
};

export const useAddBiddingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      fare?: number;
      fare_type?: string;
      company_id?: number;
      country_id?: number;
      state_id?: number;
      city_id?: string | number;
      master_package_id?: number;
      master_package_mode_id?: number;
      date_from?: string;
      date_to?: string;
      status?: number;
      currency?: string;
      vehicle_type_id?: number;
      city_distance_id?: number;
      via_city?: number;
      toll?: number;
      parking?: number;
      driver_allowance?: number;
      per_km_charge?: number;
      start_time?: string;
      end_time?: string;
      minimum_charge?: number;
      minimum_distance?: number;
      luggage_carrier?: string;
    }) => {
      const res = await api.post("/bidding/add", body, {});
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useUpdateBiddingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      route_id?: number;
      city_id?: number;
      date_from?: string;
      date_to?: string;
      modified_by?: number;
      ip?: string;
      vehicle_type_id?: number;
      city_distance_id?: number;
      via_city?: number;
      minimum_charge?: number;
      minimum_distance?: number;
      toll?: number;
      parking?: number;
      driver_allowance?: number;
      per_km_charge?: number;
      start_time?: string;
      end_time?: string;
      base_vehicle_id?: number;
      currency?: string;
      luggage_carrier?: string;
    }) => {
      const res = await api.post("/bidding/update-bidding", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useGetKilometerMutation = () => {
  return useMutation({
    mutationFn: async (body: { source_id: number; destination_id: number }) => {
      const res = await api.post("/bidding/get-distance", body, {});
      return res?.data?.responseData?.response?.data?.distance;
    },
  });
};

export const useUpdateUserStatus = () => {
  return useMutation({
    mutationFn: async (body: { id: number; isActive: string }) => {
      const res = await api.post("/user/update-user-status", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useUpdateUserType = () => {
  return useMutation({
    mutationFn: async (body: { id: number; role?: number; user_grade?: number }) => {
      const res = await api.post("/user/edit", body);
      return res?.data;
    },
  });
};

export const useGetUserStaff = () => {
  return useMutation({
    mutationFn: async (body: { user_id: number; user_type_id?: number }) => {
      const res = await api.post("/user/staff", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useDeleteUser = () => {
  return useMutation({
    mutationFn: async (body: { userId: number | number[] }) => {
      const res = await api.post("/user/delete", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useAddRelationManager = () => {
  return useMutation({
    mutationFn: async (body: { user_id: number; staff_id?: number }) => {
      const res = await api.post("/user/add-relationship-manager", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useUpdateBiddingStatus = () => {
  return useMutation({
    mutationFn: async (body: { bid_id: number[]; status?: number }) => {
      const res = await api.post("/bidding/delete-bidding", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useSendUserEmail = () => {
  return useMutation({
    mutationFn: async (body: { user_id: number; status?: string }) => {
      const res = await api.post("/user/send-email-user", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useSendUserCredentials = () => {
  return useMutation({
    mutationFn: async (body: { user_id: number; password?: string }) => {
      const res = await api.post("/user/send-credentials", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useUpdateTwoStepVerify = () => {
  return useMutation({
    mutationFn: async (body: { user_id: number; twoStepStatus: "active" | "inactive" }) => {
      const res = await api.put("/user/two-step-verify", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useGetRole = () => {
  const { setUserRoleData } = useUserRole();

  return useQuery({
    queryKey: ["GetRole"],
    queryFn: async () => {
      // Pass a high limit to get all roles (default is 10, which only shows 10 user types)
      const res = await api.get(`/roles/`, {
        params: {
          limit: 10000, // High limit to fetch all roles
          page: 1,
        },
      });
      const data = res?.data?.responseData?.response?.data?.results;
      setUserRoleData(data);
      return data;
    },
    enabled: true,
  });
};

export const useGetRoleTypes = () => {
  return useQuery({
    queryKey: ["GetRoleTypes"],
    queryFn: async () => {
      const res = await api.get(`/roles/role-types`);
      const data = res?.data?.responseData?.response?.data?.results;
      return data || [];
    },
    enabled: true,
  });
};

export const useGetDriverList = () => {
  return useMutation({
    mutationFn: async (body: {
      user_type_id: string;
      company_id?: number;
      state_id?: string | number;
      city_id?: string | number;
      status?: number
    }) => {
      const res = await api.post("/driver/driver-list", body, {});
      return res?.data?.responseData?.response.data;
    },
  });
};


export const getDriverByID = (id: number)=>{
  return useQuery({
    queryKey: ["getDriver", id],
    queryFn: async () => {
      const res = await api.get(`/driver/get-driver/${id}`);
      return res?.data?.responseData?.response?.data
    },
    enabled: !!id,
  });
}

export const updateDriver = (id: number)=>{
  return useMutation({
    mutationFn: async(body: any) => {
      const res = await api.put(`/driver/driver-update/${id}`, body);
      console.log("update driver response ", res.data)
      return res.data
    },
    onSuccess: ()=> {toast.success("Successfully updated")}
  })
}



type DriverListBody = {
  user_type_id: string;
  company_id?: number;
  state_id?: string | number;
  city_id?: string | number;
  status?: number;
};

type DriverListQuery = {
  name?: string;
  page?: number;
  limit?: number;
  sort_column?: string;
  sort_order?: "ASC" | "DESC";
};

export const useGetDriverList2 = () => {
  return useMutation({
    mutationFn: async (
      payload:
        | DriverListBody
        | {
          body: DriverListBody;
          query?: DriverListQuery;
        }
    ) => {
      // ✅ Backward compatibility
      const body =
        "body" in payload ? payload.body : payload;

      const query =
        "query" in payload ? payload.query : undefined;

      const res = await api.post(
        "/driver/driver-list",
        body,
        { params: query }
      );

      // ✅ ALWAYS return array
      return res?.data?.responseData?.response?.data?.data || [];
    },
  });
};


export const useGetDriverListRecent = () => {
  return useMutation({
    mutationFn: async (body: {
      user_type_id: string;
      company_id?: number;
      user_id?: number;
    }) => {
      const res = await api.post("/driver/recent-drivers", body, {});
      return res?.data?.responseData?.response;
    },
    onError: (err) => {
      console.error(err);
    },
  });
};

export const useFetchUsersByFilters = () => {
  const { token } = useAuth();

  return useMutation({
    mutationFn: async ({
      user_type_id,
      state_id,
      city_id,
      company_id,
      limit = 200,
      page = 1,
    }: {
      user_type_id: string | number;
      state_id?: string | number;
      city_id?: string | number;
      company_id?: string | number;
      limit?: number;
      page?: number;
    }) => {
      const res = await api.get("/user", {
        params: {
          page,
          limit,
          user_type_id: user_type_id ? Number(user_type_id) : undefined,
          state_id: state_id ? Number(state_id) : undefined,
          city_id: city_id ? Number(city_id) : undefined,
          company_id: company_id ? Number(company_id) : undefined,
        },
        headers: token
          ? {
            Authorization: `Bearer ${token}`,
          }
          : undefined,
      });
      const response = res?.data?.responseData?.response;
      const responseData = response?.data;
      const responseResults = response?.results;
      const responseUsers = response?.users;
      const nestedUsers = responseData?.users;
      const fallbackData = res?.data?.data;

      if (Array.isArray(response)) return response;
      if (Array.isArray(responseUsers)) return responseUsers;
      if (Array.isArray(nestedUsers)) return nestedUsers;
      if (Array.isArray(responseData)) return responseData;
      if (Array.isArray(responseResults)) return responseResults;
      if (Array.isArray(response?.response?.data))
        return response.response.data;
      if (Array.isArray(fallbackData)) return fallbackData;

      return [];
    },
  });
};

export const useGetTopUser = () => {
  return useQuery({
    queryKey: ["TopUser"],
    queryFn: async () => {
      const res = await api.get("/user/get-top-user");
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useGetCompanyDetail = () => {
  const user = useAuth();
  const user_id = user?.user?.id;
  // console.log();
  return useQuery({
    queryKey: ["CompanyDetail"],
    queryFn: async () => {
      const res = await api.get(`/company/`);
      const data = res?.data?.responseData?.response?.data;
      return data;
    },
    enabled: true,
  });
};

export const useGetCompanyDetailsId = (id: number, options = {}) => {
  // console.log();
  return useQuery({
    queryKey: ["CompanyDetail", id],
    queryFn: async () => {
      const res = await api.get(`/company/get/${id}`);
      const data = res?.data?.responseData?.response?.data;
      return data;
    },
    enabled: !!(id && id > 0),
    ...options
  });
};

export const useGetUserDoc = () => {
  return useMutation({
    mutationFn: async (body: { user_id: string; doc_type?: string }) =>
      await api.post("/user/get-user-doc", body, {}),
  });
};

// get UserVehhicleDoc
export const useGetVehicleDocs = (vehicle_id: string) => {
  return useQuery({
    queryKey: ["vehicle-documents", vehicle_id],
    queryFn: async () => {
      if (!vehicle_id) return [];
      const response = await api.get(
        `/userVehicleDocument?vehicle_id=${vehicle_id}`
      );

      return response.data?.responseData?.response?.data?.docs || [];
    },
    enabled: !!vehicle_id,
  });
};

export const useUpdateUserDocStatus = () => {
  return useMutation({
    mutationFn: async (body: { upload_doc_id: number; status: number }) =>
      await api.put("/userDocument/update", body, {}),
  });
};

// getVehicleTypeList

export const getVehicleTypeList = () => {
  return useQuery({
    queryKey: ["GetVehicleList"],
    queryFn: async () => {
      // Request a high limit to get all vehicle types
      const res = await api.get(`/vehicle/vehicle-type`, {
        params: {
          page: 1,
          limit: 1000, // High limit to get all vehicle types
        },
      });
      // Handle different response structures
      const vehicleModelType = 
        res?.data?.responseData?.response?.data?.vehicleModelType ||
        res?.data?.data?.vehicleModelType ||
        res?.data?.vehicleModelType ||
        [];
      
      // Return all vehicle types (for management components that need to see all statuses)
      return Array.isArray(vehicleModelType) ? vehicleModelType : [];
    },
    enabled: false,
  });
};

// Get only active vehicle types (status = 1) for dropdowns
export const getActiveVehicleTypeList = () => {
  return useQuery({
    queryKey: ["GetActiveVehicleList"],
    queryFn: async () => {
      // Request a high limit to get all vehicle types
      const res = await api.get(`/vehicle/vehicle-type`, {
        params: {
          page: 1,
          limit: 1000, // High limit to get all vehicle types
        },
      });
      // Handle different response structures
      const vehicleModelType = 
        res?.data?.responseData?.response?.data?.vehicleModelType ||
        res?.data?.data?.vehicleModelType ||
        res?.data?.vehicleModelType ||
        [];
      
      // Filter active vehicle types (status = 1) for dropdown
      const activeVehicleTypes = Array.isArray(vehicleModelType)
        ? vehicleModelType.filter((type: any) => type?.status === 1)
        : [];
      
      return activeVehicleTypes;
    },
    enabled: false,
  });
};

export const useUpdateVehicleTypeStatus = () => {
  return useMutation({
    mutationFn: async (body: { id: number[]; status?: number }) => {
      const res = await api.put("/vehicle/vehicle-type/update", body, {});
      return res?.data?.responseData?.response;
    },
  });
};
export const getVehicleNameTypeList = () => {
  return useQuery({
    queryKey: ["GetVehicleNameList"],
    queryFn: async () => {
      const res = await api.get(`/vehicle/vehicle-type/get-name`);
      const data = res?.data?.responseData?.response?.data?.vehicleNameData;
      return data;
    },
    enabled: false,
  });
};

export const useUpdateVehicleTypeOrder = () => {
  return useMutation({
    mutationFn: async (body: { id: number[]; display_order?: number[] }) => {
      const res = await api.put("/vehicle/vehicle-type/order", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

type AddVehicleTypeInput = {
  file: File;
  folder: string;
  category_id: string;
  status: string;
  vehicle_type: string;
  seating_capacity: number;
  luggage: number;
  display_order: number;
};

type AddVehicleNameInput = {
  file: File;
  folder: string;
  category_id: string;
  status: string;
  vehicle_type: string;
  vehicle_type_name: string;
  name: string;
  person_capacity: string;
  luggage_capacity: string;
  small_suitcase: string;
  amenities: string;
  amenities_id: string;
  id?: string;
};

export const useAddVehicleType = () => {
  return useMutation({
    mutationFn: async (input: AddVehicleTypeInput) => {
      const formData = new FormData();
      Object.entries(input).forEach(([key, value]) =>
        formData.append(key, value as string)
      );
      const res = await api.post(
        "/vehicle/vehicle-type/add?folder=vehicle-type-image",
        formData
      );
      return res?.data?.responseData?.response ?? {};
    },
  });
};

export interface UpdateVehicleTypeInput {
  id: number;
  vehicle_type?: string;
  seating_capacity?: number;
  luggage?: number;
  display_order?: number;
  status?: string;
  file?: File;
}

export const useUpdateVehicleTypeDetails = () => {
  return useMutation({
    mutationFn: async (input: UpdateVehicleTypeInput) => {
      const formData = new FormData();

      // Append all fields to FormData, similar to addVehicleType
      Object.entries(input).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });

      const res = await api.put(
        "/vehicle/vehicle-type/update-details?folder=vehicle-type-image",
        formData
      );
      return res?.data?.responseData?.response ?? {};
    },
  });
};
export const useUpdateVehicleNameData = () => {
  return useMutation({
    mutationFn: async (input: AddVehicleNameInput) => {
      const formData = new FormData();
      Object.entries(input).forEach(([key, value]) =>
        formData.append(key, value)
      );

      const res = await api.put(
        `/vehicle/vehicle-type/update-name-data?folder=${input.folder}`,
        formData
      );
      return res?.data?.responseData?.response ?? {};
    },
  });
};
export const useAddVehicleName = () => {
  return useMutation({
    mutationFn: async (input: AddVehicleNameInput) => {
      console.log("input while adding", input);
      const formData = new FormData();
      Object.entries(input).forEach(([key, value]) =>
        formData.append(key, value)
      );
      const res = await api.post(
        `/vehicle/vehicle-type/add-name?folder=${encodeURIComponent(
          input.folder
        )}`,
        formData
      );
      return res?.data?.responseData?.response ?? {};
    },
  });
};

export const useDeleteVehicleStatusMutation = (
  onSuccessCallback?: () => void
) => {
  return useMutation({
    mutationFn: async (body: { id: number }) => {
      const res = await api.delete("/booking/delete-recently-viewed", {
        data: body,
      });
      return res?.data?.responseData?.response?.data?.result;
    },
    onSuccess: () => {
      if (onSuccessCallback) onSuccessCallback();
    },
  });
};

export const useUpdateVehicleNameStatus = () => {
  return useMutation({
    mutationFn: async (body: { id: number[]; status?: number }) => {
      const res = await api.put("/vehicle/vehicle-type/update-name", body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const getVehicleAmenitiesList = () => {
  return useQuery({
    queryKey: ["GetVehicleAmenitiesList"],
    queryFn: async () => {
      const res = await api.get(`/vehicle/vehicle-type/amenities`);
      const data = res?.data?.responseData?.response?.data?.amenitiesData;
      return data;
    },
    enabled: false,
  });
};

export const useAddAmenities = () => {
  return useMutation({
    mutationFn: async (body: {
      amenities_name: string;
      status: number;
      display_order: number;
    }) => {
      const res = await api.post("/vehicle/vehicle-type/add-amenities", body);
      return res?.data?.responseData?.response ?? {};
    },
  });
};

export const useUpdateAmenitiesStatus = () => {
  return useMutation({
    mutationFn: async (body: { id: number[]; status?: number }) => {
      const res = await api.put(
        "/vehicle/vehicle-type/update-amenities",
        body,
        {}
      );
      return res?.data?.responseData?.response;
    },
  });
};

export const useUpdateAmenitiesData = () => {
  return useMutation({
    mutationFn: async (body: {
      id: number;
      status?: number;
      display_order?: number;
      amenities_name?: string;
    }) => {
      const res = await api.put(
        "/vehicle/vehicle-type/update-amenities-data",
        body,
        {}
      );
      return res?.data?.responseData?.response;
    },
  });
};

export const useAddUserVehicleMutation = () => {
  return useMutation({
    mutationFn: async (body: addCabForm) => {
      const res = await api.put("/vehicle/vehicle-type/add-user-vehicle", body);
      return res?.data?.responseData?.response;
    },
  });
};
export const useUpdateUserVehicleMutation = () => {
  return useMutation({
    mutationFn: async (body: addCabForm) => {
      const res = await api.put(
        "/vehicle/vehicle-type/update-vehicle-detail",
        body
      );
      return res?.data?.responseData?.response;
    },
  });
};

export const getVehicleColorList = () => {
  return useQuery({
    queryKey: ["GetVehicleColorList"],
    queryFn: async () => {
      const res = await api.get(`/vehicle/vehicle-type/vehicle-color-combo`);
      const data = res?.data?.responseData?.response?.data?.results;
      return data;
    },
    enabled: false,
  });
};
// export const getVehicleUserList = () => {
//   return useQuery({
//     queryKey: ["GetVehicleUserList"],
//     queryFn: async () => {
//       const res = await api.get(`/vehicle/vehicle-type/user-vehicle-list`);
//       const data = res?.data?.responseData?.response?.data?.results;
//       return data;
//     },
//     enabled: false,
//   });
// };

export const getVehicleUserList = ({
  vehicle_master_id,
  vehicle_no,
  enabled = false,
}: {
  vehicle_master_id?: string | number;
  vehicle_no?: string;
  enabled?: boolean;
} = {}) => {
  return useQuery({
    queryKey: ["GetVehicleUserList", { vehicle_master_id, vehicle_no }],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (vehicle_master_id)
        params.append("vehicle_master_id", String(vehicle_master_id));
      if (vehicle_no) params.append("vehicle_no", vehicle_no);

      const queryString = params.toString() ? `?${params.toString()}` : "";
      const res = await api.get(
        `/vehicle/vehicle-type/user-vehicle-list${queryString}`
      );
      const data = res?.data?.responseData?.response?.data?.results;

      return data;
    },
    enabled: false,
  });
};

export const useUpdateUserVehicleStatus = () => {
  return useMutation({
    mutationFn: async (body: { id: number[]; status?: number }) => {
      const res = await api.put(
        "/vehicle/vehicle-type/update-user-status",
        body,
        {}
      );
      return res?.data?.responseData?.response;
    },
  });
};

export const useUploadVehicleDoc = () => {
  return useMutation({
    mutationFn: async (input: AddVehicleTypeInput) => {
      const formData = new FormData();
      Object.entries(input).forEach(([key, value]) =>
        formData.append(key, value as string)
      );
      const res = await api.post(
        "/vehicle/vehicle-type/add?folder=vehicle-type-image",
        formData
      );
      return res?.data?.responseData?.response ?? {};
    },
  });
};
export const useDriverCombo = () => {
  return useQuery({
    queryKey: ["DriverComboList"],
    queryFn: async () => {
      const res = await api.get(`/driver/driver-combo`);
      return res;
    },
    enabled: true,
  });
};

export const useMapUserWithVehicle = () => {
  return useMutation({
    mutationFn: async (body: {
      user_id: string;
      user_vehicle_id: string;
      status: string;
    }) => {
      const res = await api.put(
        "/vehicle/vehicle-type/map-user-vehicle",
        body,
        {}
      );
      return res?.data?.responseData?.response;
    },
  });
};

// getDriverCombo

// export const useVerfiyOtpDataMutation = () => {
//     return useMutation({
//         mutationFn: (country: string) =>
//             api.post('/user/country-name', { country }),
//         onSuccess: (res) => {
//             const countryData = res?.data?.responseData?.response?.data?.countryData;
//             return
//         },
//         onError: (err) => {
//             console.error(MESSAGES.FAILED_FETCHED, err);
//         }
//     })
// }

interface BookingSearchRequest {
  // Booking details
  booking_id?: string;
  booking_type?: string;
  reference_number?: any;
  // Vehicle details
  vehicle_owner?: string;
  vehicle_type?: string;
  vehicle_no?: string;
  // Driver details
  driver_name?: string;
  driver_first_name?: string;
  driver_last_name?: string;
  driver_id?: string;
  driver_rating?: any;
  driver_email?: string;
  driver_mobile_no?: string;
  // Partner details
  partner_name?: string;
  // Client details
  client_first_name?: string;
  client_last_name?: string;
  client_id?: string;
  client_rating?: any;
  client_mobile_no?: string;
  client_email?: string;
  // Referral
  referral_key?: string;
  // Date filters
  from_date?: string;
  to_date?: string;
  // Pagination
  limit?: number;
  pageNumber?: number;
  //Payment Type
  payment_type: string;
}

export const useBookingHistoryList = () => {
  return useMutation({
    mutationFn: async (body: BookingSearchRequest) => {
      const response = await api.post("/booking/bookingSearch", body);
      return response.data;
    },
  });
};

// updatePickupDateTime
export const updatePickupDateTime = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const response = await api.post("/booking/updatePickupDateTime", body);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

//update Rating
export const useUpdateRating = () => {
  return useMutation({
    mutationFn: async (payload: {
      booking_Id: string;
      driver_Id: number;
      user_Id: number;
      rating: number;
    }) => {
      const response = await api.post("/booking/updateClientRating", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const getDriverDocuments = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/booking/getdiverdocuments", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const getVehicleDocuments = (vehicle_id?: string | number) => {
  return useQuery({
    queryKey: ["userVehicleDocument", vehicle_id],
    queryFn: async () => {
      if (!vehicle_id) throw new Error("User ID is required");

      const response = await api.get(
        `/userVehicleDocument?vehicle_id=${vehicle_id}`
      );

      return response.data?.responseData?.response?.data;
    },
    enabled: false,
  });
};

export const getVehicleDocumentsNew = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/user/get-user-doc", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const cancelBookingDriver = () => {
  return useMutation({
    mutationFn: async (payload: CancelBookingPayload) => {
      const response = await api.post("/booking/cancelBookingDriver", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const upateBookingStatus = () => {
  return useMutation({
    mutationFn: async (payload: UpdateBookingPayload) => {
      const response = await api.post("/booking/upateBookingStatus", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useExecuteNoShow = () => {
  return useMutation({
    mutationFn: async (payload: ExecuteNoShowPayload) => {
      const response = await api.post("/booking/executeNoShow", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useReDispatch = () => {
  return useMutation({
    mutationFn: async (payload: ReDispatchPayload) => {
      const response = await api.post("/booking/reDispatch", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const handleBookingListMutation = () => {
  return useMutation<BookingListResponse, Error, BookingListPayload>({
    mutationFn: async (body: any) => {
      const res = await api.post("/booking/booking-list", body);
      return res?.data?.responseData?.response?.data?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetCompanyDetailById = (
  companyId: string | number | undefined
) => {
  return useQuery<CompanyDetailResponse>({
    queryKey: ["CompanyDetail", companyId],
    queryFn: async () => {
      // if (!companyId) throw new Error("Company ID is required");
      const res = await api.get(`/company/`);
      return res?.data?.responseData?.response?.data?.companyData;
    },
    enabled: true,
  });
};

export const updateUserStatusMutation = () => {
  return useMutation<any, Error, UpdateUserStatusPayload>({
    mutationFn: async (body: any) => {
      const res = await api.post("/booking/updateUserStatus", body);
      return res?.data?.responseData?.response?.data?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useSendSMSMutation = () => {
  return useMutation<any, Error, SendMessagePayload>({
    mutationFn: async (body: any) => {
      const res = await api.post("/booking/smstoclient", body);
      return res?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useCompanydetails = () => {
  return useMutation<any, Error, CompanyDetailsPayload>({
    mutationFn: async (body: any) => {
      const res = await api.post("/company/company-detail", body);
      return res?.data?.responseData?.response?.data?.companyData;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const bookingFilterDispatch = () => {
  return useMutation({
    mutationFn: async (payload: ReDispatchPayloadFilter) => {
      const response = await api.post("/booking/bookingFilter", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

//getbookingbyitenearyi
export const getbookingbyitenearyid = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post(
        "/booking/getbookingbyitenearyid",
        payload
      );
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const getbookingbookingLogs = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/booking/bookingLogs", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

//booking-info
export const getbookingInfo = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/booking/booking-info", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

//way point
export const getWaypointInfo = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/driver/way-point-seq", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useAdvanceToVendor = () => {
  //advanceToVendor
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/payment/advanceToVendor", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
    onSettled: () => {
      console.log("Mutation settled (success or error)");
    },
  });
};

export const useSendWhatsAppMessage = () => {
  //advanceToVendor
  return useMutation({
    mutationFn: async (payload: any) => {
      console.log("API call triggered with payload:", payload);
      const response = await api.post("/booking/sendwhatsAppMessage", {
        phoneNumber: "7818886071",
      });
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useCompleteCabBilling = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/driver/cab-billing-complete", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetBookingTemplate = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/booking/getBookingTemplate", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetgetDriverClaimList = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post("/booking/getDriverClaimList", payload);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};
export const useGetGSTNumberVerificationMutation = () => {
  return useMutation({
    mutationFn: (gst: string) => api.post("/user/gst-verification", { gst }),
    onSuccess: (res) => {
      const data = res?.data?.responseData?.response?.data;
      return data;
    },
    onError: (err) => {
      console.error(MESSAGES.FAILED_FETCHED, err);
    },
  });
};

export const useUpdateCompanyInfo = () => {
  return useMutation({
    mutationFn: ({
      id,
      ...body
    }: { id: string | number } & CompanyInfoRequest) =>
      api.put(`/company/company-detail/${id}`, body, {}),
    onSuccess: (res) => {
      const companyData = res?.data?.responseData?.response?.data?.countryData;
    },
  });
};

export const useGetStatementOfAccount = (limit: number) => {
  // return useQuery({
  //   queryKey: ["statementOfAccountList", limit],
  //   queryFn: async () => {
  //     const res = await api.post('/booking/get-statment-account', { limit });
  //     return res?.data?.responseData?.response?.data?.data;
  //   }
  // });

  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/booking/get-statment-account", payload);
      return res?.data?.responseData?.response?.data?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetAllCreditLimitTransactions = () => {
  return useMutation({
    mutationFn: async (payload: { user_id: any; company_id: any }) => {
      const res = await api.post("/creditLimit/", payload);
      return res?.data?.responseData?.response?.data?.allUserCreditLimit;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetBilling = () => {
  return useMutation({
    mutationFn: async (payload?: any) => {
      const res = await api.post("/booking/get-billing", payload, {});
      return res?.data?.responseData?.response?.data;
    },
  });
};

//get-company-markup-log
export const useGetMarkupList = () => {
  return useMutation({
    mutationFn: async (payload: GetMarkupPayload) => {
      const {
        page = 1,
        pageSize = 10,
        country_id = "",
        state_id = "",
        city_id = "",
        user_grade = "",
        master_booking_type_id = "",
      } = payload;

      const res = await api.post("/city/get-markup", {
        page,
        pageSize,
        country_id,
        state_id,
        city_id,
        user_grade,
        master_booking_type_id,
      });
      console.log(res, "res");
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetMarkupLogsList = () => {
  return useMutation({
    mutationFn: async (payload: GetMarkupLogsPayload) => {
      const { markup_id } = payload;

      const res = await api.post("/city/get-company-markup-log", {
        markup_id,
      });
      console.log(res, "res");
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useUpdateMarkupStatus = () => {
  return useMutation({
    mutationFn: async (payload: updateMarkupPayload) => {
      const { id, user_id, markup_status } = payload;
      const res = await api.post("/city/update-markup-status", {
        id,
        user_id,
        markup_status,
      });
      console.log(res, "res");
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useAddMarkupStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/city/add-company-markup", payload);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useEditMarkup = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/city/update-markup", payload);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetCountries = () => {
  return useQuery({
    queryKey: ["getcountries"],
    queryFn: async () => {
      const res = await api.get("/country/get-country");
      return res?.data?.responseData?.response?.data;
    },
    enabled: true,
  });
};

export const usegetCitiesMarkup = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/city/get-cities", payload);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const usegetStateMarkup = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/city/get-states", payload);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const usegetCountryMarkup = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/city/get-countries", payload);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const usedeleteMarkup = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/city/delete-markup", payload);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const handleBookingCountMutation = () => {
  return useMutation<BookingListResponse, Error, BookingCountPayload>({
    mutationFn: async (body: any) => {
      const res = await api.post("/booking/booking-count", body);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

//ICYG03675
export const handleBookingItenaryMutation = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/booking/get-bookingby-iteneary", body);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};
export const useLocalPackages = (id: string | number | null) => {
  return useQuery({
    queryKey: ["localPackages"],
    queryFn: async () => {
      const res = await api.get("/local/get-local-package-master", {
        params: { id },
      });
      return res?.data?.data;
    },
  });
};

export const useLocalPackagesActive = (booking_mode: any) => {
  return useQuery({
    queryKey: ["localPackages", booking_mode],
    queryFn: async () => {
      const res = await api.get(`/local/get-local-package`, {
        params: { booking_mode },
      });
      return res?.data?.data;
    },
  });
};

export const useLocalPackagesByCity = (params: any) => {
  return useQuery({
    queryKey: ['localPackages', params],
    queryFn: () => api.get(`/local/get-local-package`, {
      params: params,
    }),
    enabled: !!params?.city_id && !!params?.booking_mode,
  });
};

export const useChangeLocalPackageStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/local/update", body);
      return res?.data;
    },
    onSuccess: () => {
      // Invalidate localPackages query so list refreshes
      queryClient.invalidateQueries({ queryKey: ["localPackages"] });
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};
export const useEditLocalPackage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/local/edit", body);
      return res?.data;
    },
    onSuccess: () => {
      // Invalidate localPackages query so list refreshes
      queryClient.invalidateQueries({ queryKey: ["localPackages"] });
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const getFareListData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/fare_management/get_fare_list_data", body);
      return res?.data;
    },
    onSuccess: () => {
      // Invalidate localPackages query so list refreshes
      queryClient.invalidateQueries({ queryKey: ["localPackages"] });
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const useGetPackageMode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/fare_management/getPackageMode", body);
      return res?.data;
    },
    onSuccess: () => {
      // Invalidate localPackages query so list refreshes
      queryClient.invalidateQueries({ queryKey: ["localPackages"] });
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};

export const getCityByname = (city: string) => {
  return useQuery({
    queryKey: ["SearchCity", city],
    queryFn: () =>
      api
        .get(`/city/packageCity?city_name=${city}&toCity=${true}`)
        .then((res) => res?.data),
    // return res?.data?.responseData?.response?.data;

    enabled: !!city, // Prevent auto-fetching
  });
};

export const getDetailedAddress = (address: string) => {
  return useQuery({
    queryKey: ["DetailedAddress", address],
    queryFn: () =>
      api.post(`/adress/search-addresses`, {
        search_term: address
      }).then((res) => {
        // Handle response structure: { status: "success", data: [...] }
        if (res?.data?.data && Array.isArray(res.data.data)) {
          return res.data.data;
        }
        // Handle responseData structure: { responseData: { response: { status, data, message } } }
        if (res?.data?.responseData?.response?.data) {
          return res.data.responseData.response.data;
        }
        // Fallback for different response structures
        if (res?.data?.data) {
          return res.data.data;
        }
        return res?.data || [];
      }),
    enabled: !!address && address.length > 0, // Only fetch if address has content
  });
};

export const getNationality = (nationality: string) => {
  return useGetNationality(nationality);
};

export const useUpsertLocalPackageFare = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/local/fare/upsert", body);
      return res?.data;
    },
    onSuccess: () => { },
    onError: (error: Error) => {
      console.error("Error upserting local package fare:", error);
      return error?.message;
    },
  });
};
export const useGetLocalPackageFare = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.get("/fare_management/get-local-package-fare", {
        params: body,
      });
      return res?.data?.responseData?.response?.data;
    },
    onSuccess: () => { },
    onError: (error: Error) => {
      console.error("Error upserting local package fare:", error);
      return error?.message;
    },
  });
};

export const useGetDistanceHourFare = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.get("/fare_management/get-distance-hour-fare", {
        params: body,
      });
      return res?.data;
    },
    onSuccess: () => { },
    onError: (error: Error) => {
      console.error("Error upserting Distance Hour fare:", error);
      return error?.message;
    },
  });
};
export const useUpsertDistanceHourFare = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post(
        "/fare_management/distance-hour-fare-update",
        body
      );
      return res?.data;
    },
    onSuccess: () => {
      toast.success("Distance hour fare saved ✅");
    },
    onError: (error: Error) => {
      console.error("Error upserting Distance Hour fare:", error);
      return error?.message;
    },
  });
};
export const useAddNewFare = () => {
  const { fare, setAddedFare } = useAddedFare();
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/fare_management/addfare", body);
      return res.data;
    },
    onSuccess: (data) => {
      console.log("sUCESSSSS", data);
      setAddedFare({
        base_vehicle_id: data.base_vehicle_id,
        fare_id: data.fare_id,
        booking_type: data?.booking_type,
      });
      toast.success("Fare added successfully 🎉");
    },
    onError: (error: Error) => {
      console.error("Error Adding fare:", error);
      return error?.message;
    },
  });
};

export const useGetDistanceWaitingFare = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.get("/fare_management/get-distance-waiting-fare", {
        params: body,
      });
      return res?.data;
    },
    onSuccess: () => { },
    onError: (error: Error) => {
      console.error("Error upserting Distance Hour fare:", error);
      return error?.message;
    },
  });
};
export const useUpsertDistanceWaitingFareUpdate = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/fare_management/distance-waiting-add", body);
      return res?.data;
    },
    onSuccess: () => { },
    onError: (error: Error) => {
      console.error("Error Adding fare:", error);
      return error?.message;
    },
  });
};
export const useUpsertDistanceFare = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/fare_management/distance-fare-add", body);
      return res?.data;
    },
    onSuccess: () => {
      toast.success("Distance fare saved ✅");
    },
    onError: (error: Error) => {
      console.error("Error Adding fare:", error);
      return error?.message;
    },
  });
};
export const useGetDistanceFares = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.get("/fare_management/get-distance-fare", {
        params: body,
      });
      return res?.data;
    },
    onSuccess: () => {
      // Invalidate localPackages query so list refreshes
      queryClient.invalidateQueries({ queryKey: ["localPackages"] });
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};
export const useGetDistanceUptoFares = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.get("/fare_management/get-distance-upto-rate", {
        params: body,
      });
      return res?.data;
    },
    onSuccess: () => {
      // Invalidate localPackages query so list refreshes
      queryClient.invalidateQueries({ queryKey: ["localPackages"] });
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};
export const useUpsertDistanceUptoFare = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post(
        "/fare_management/distance-fare-upto-add",
        body
      );
      return res?.data;
    },
    onSuccess: () => {
      toast.success("Distance upto fare saved ✅");
    },
    onError: (error: Error) => {
      console.error("Error Adding fare:", error);
      return error?.message;
    },
  });
};
export const useGetHourlyFares = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.get("/fare_management/get-hourly-fare", {
        params: body,
      });
      return res?.data;
    },
    onSuccess: () => {
      // Invalidate localPackages query so list refreshes
      // queryClient.invalidateQueries({ queryKey: ["localPackages"] });
    },
    onError: (error: Error) => {
      return error?.message;
    },
  });
};
export const useUpsertHourlyFare = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/fare_management/hourly-fare-upsert", body);
      return res?.data;
    },
    onSuccess: () => {
      toast.success("Hourly fare saved ✅");
    },
    onError: (error: Error) => {
      console.error("Error Adding fare:", error);
      return error?.message;
    },
  });
};

export const useGetSacCodeData = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: any) => {
      const res = await api.post("/fare/get-sac-code", { id });
      return res?.data?.data?.[0];
    },
    onError: (err: Error) => {
      return err?.message;
    },
  });
};
export const useGetSacCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.get("/code/get-sac-codes", {
        params: payload,
      });
      return res?.data?.data;
    },
    onError: (err: Error) => {
      return err?.message;
    },
  });
};
export const useGetUserTaxDetailData = (filters: Record<string, any> = {}) => {
  const cleanFilters = Object.fromEntries(
    Object.entries(filters).filter(([_, v]) => v !== undefined && v !== "")
  );

  return useQuery<UserResponse, Error>({
    queryKey: ["userTaxDetails", cleanFilters],
    queryFn: async () => {
      const res = await api.get("/fare_management/getusertaxdetailData", {
        params: {
          ...cleanFilters,
        },
      });
      return res?.data?.responseData?.response;
    },
  });
};

export const useUpateTaxDetail = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.put("/fare_management/updatetaxdetail", body, {}),
    onSuccess: (res) => {
      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};

export const useaddBasicTax = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) => api.post("/code/add-basic-tax", body),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ["cleanFilters"] });

      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};

export const usegetBasicTax = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) => api.get("/code/get-basic-tax", { params: body }),

    onSuccess: (res) => {
      // queryClient.invalidateQueries({ queryKey: ["cleanFilters"] });

      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};
export const usegetBasicFareSetting = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-basic-fare-setting", { params: body }),
    onSuccess: (res) => {
      // queryClient.invalidateQueries({ queryKey: ["cleanFilters"] });

      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};
export const useaddBasicFareSetting = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/add-basic-fare-setting", body),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ["cleanFilters"] });

      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};

export const useAddTaxDetail = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/add-tax-detail", body),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ["userTaxDetails"] });

      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};

export const usegetTaxDetail = () => {
  return useQuery({
    queryKey: ["taxDetail"],
    queryFn: () =>
      api.get(`/fare_management/get-tax-detail`).then((res) => res.data),
  });
};

export const useChangeTaxDetailStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/tax-detail-status", body),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ["userTaxDetails"] });

      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};
export const usegetCancellationMasters = (params: any) => {
  return useQuery({
    queryKey: ["CancellationName"],
    queryFn: () =>
      api
        .get(`/fare_management/get-cancellation-masters`, { params: params })
        .then((res) => res.data),
  });
};

export const useUpsertCancellationFare = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-cancellation-fare", body),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: ["cancellationFare"] });

      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};
export const usegetCancellationFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-cancellation-fares", {
        params: body,
      }),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useUpsertPrewaitingFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-prewaiting-fare", body),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const usegetWaitingFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-waiting-fare", { params: body }),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const usegetPreWaitingFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-prewaiting-fare", { params: body }),
    onSuccess: (res) => {
      return true;
    },
  });
};

export const useUpserteWaitingFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-waiting-fare", body),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const usegetPostalCodeFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-postal-code-fare", { params: body }),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useUpsertPostalCodeFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-postal-code", body),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useUpsertCompanyShare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-company-share", body),
    onSuccess: (res) => {
      toast.success("Company share Updated ✅");
      return true;
    },
  });
};
export const useGetCompanyShare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-company-share", { params: body }),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const usegetNightCharge = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-night-fare", { params: body }),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useUpsertNightCharge = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-night-fare", body),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const usegetPremiumFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-premium-fare", { params: body }),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useUpsertPremiumFare = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-premium-fare", body),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const usegetPeakTimeCharge = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-peak-time-charge", { params: body }),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useUpsertPeakTimeCharge = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-peak-time-charge", body),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useGetextraCharge = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.get("/fare_management/get-extra-charge", { params: body }),
    onSuccess: (res) => {
      return true;
    },
  });
};

export const useUpsertextraCharge = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/fare_management/upsert-extra-charge", body),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useGetNationality = (nationality: string) => {
  return useQuery({
    queryKey: ["nationality", nationality],
    queryFn: () =>
      api
        .get("/country/get-country", {
          params: { country_name: nationality },
        })
        .then((res) => res.data.responseData.response.data),
    enabled: !!nationality,
  });
};

// export const useGetStates = (countryId: any) => {
//   return useQuery({
//     queryKey: ["states", countryId],
//     enabled: !!countryId, // prevents query if undefined
//     queryFn: async () => {
//       const res = await api.get(`/states?country_id=${countryId}`);
//       return res?.data?.data || [];
//     },
//   });
// };

export const useGetStates = (countryId: any) => {
  const query = useQuery({
    queryKey: ["states", countryId],
    enabled: !!countryId,
    queryFn: async () => {
      const res = await api.get(`/states?country_id=${countryId}`);
      return res?.data?.data || [];
    },
  });

  return {
    ...query,
    refetchStates: query.refetch, // Optional alias
  };
};

// export const useGetCities = (stateId: any) => {
//   return useQuery({
//     queryKey: ["cities", stateId],
//     enabled: !!stateId, // prevents query if undefined
//     queryFn: async () => {
//       const res = await api.get(`/city/cities?state_id=${stateId}`);
//       return res?.data?.data || [];
//     },
//   });
// };

export const useGetCities = (stateId: any) => {
  const query = useQuery({
    queryKey: ["cities", stateId],
    enabled: !!stateId,
    queryFn: async () => {
      const res = await api.get(`/city/cities?state_id=${stateId}`);
      return res?.data?.data || [];
    },
  });

  return {
    ...query,
    refetchCities: query.refetch, // Optional alias
  };
};

// hooks/useCommon.ts
export const useGetCompany = (filter: any) => {
  return useQuery({
    queryKey: ["companies"], // Changed from "cities" to "companies"
    queryFn: async () => {
      const res = await api.get(`/company/get-companies`, {
        params: filter,
      });
      return res.data.data || []; // Return res.data instead of res
    },
    // Add these options for better debugging
    retry: 1,
    refetchOnWindowFocus: false,
  });
};

export const useChangeFareStatus = () => {
  return useMutation({
    mutationFn: (body: any) => api.post("/fare_management/fare-status", body),
    onSuccess: (res) => {
      return true;
    },
  });
};

export const useAddDepartmentMutation = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/user/department/add", body);
      return res?.data;
    },
  });
};


export const useAddRoleMutation = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/roles/create", body);
      return res?.data;
    },
  });
};

export const useUpdateRoleMutation = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.put("/roles/update", body);
      return res?.data;
    },
  });
};

export const useDeleteRoleMutation = () => {
  return useMutation({
    mutationFn: async (body: { id?: number; ids?: number[] }) => {
      const res = await api.post("/roles/delete", body);
      return res?.data;
    },
  });
};

export const useUpdateRoleStatus = () => {
  return useMutation({
    mutationFn: async (body: { ids: number[]; status: number }) => {
      const res = await api.post("/roles/update-status", body);
      return res?.data?.responseData?.response;
    },
  });
};

export const useDepartmentsQuery = () => {
  return useQuery({
    queryKey: ["departments"],
    queryFn: async () => {
      const res = await api.get("/user/department/get-all");
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useGetCityByName = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/city/get-city-by-name", body);
      return res?.data?.responseData?.response?.data;
    },
  });
};

// export const useGetUserBookingTypeMapping = () => {
//   return useMutation({
//     mutationFn: async(body: any) => {
//       const res = await api.post('/user/booking-type-mapping',body);
//       console.log(res?.data);
//       return res?.data;
//     }
//   })
// }

export const useGetUseBookingCount = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/user/booking-count", body);
      return res?.data;
    },
  });
};

export const useGetUserDriverList = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/driver/get-driver-list", body);
      return res?.data?.responseData?.response?.data || [];
    },
    onError: (err: Error) => {
      return err?.message;
    },
  });
};

// export const useGetUserBookingTypeMapping = (body: any) => {
//   return useQuery({
//     queryKey: ["bookingTypeMapping", body],
//     enabled: !!body,
//     queryFn: async () => {
//       const res = await api.get('/user/booking-type-mapping');
//       return res?.data?.data || [];
//     }
//   });
// };

export const useGetUserBookingTypeMapping = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const {
        // limit = 0,
        // offet = 10,
        // user_id = "",
        // booking_type = "",
        // state_id = "",
        // auto_id = "",
        // city_id = "",
        // country_id = "",
        // mapping_category = "",
        // vehicle_type = "",
        // booking_type_mode = "",
        // status = "",
      } = payload;
      const res = await api.post("/user/booking-type-mapping", payload);
      console.log(res?.data?.responseData?.response?.data);
      return res?.data?.responseData?.response?.data?.data;
    },
    onError: (error: Error) => {
      console.log(error?.message);
      return error?.message;
    },
  });
};

export const useUpdateBookingTypeMapping = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.put("/user/update-booking-mapping-detail", body),
    onSuccess: (res: any) => {
      return true;
    },
  });
};

export const usePackageMappingMutation = () => {
  return useMutation({
    mutationFn: async (body: {
      user_id?: string;
      country_id?: string;
      mapping_category?: string;
      mapping_package_id?: string;
      mapping_package_mode_id?: string;
      vehicle_type?: string;
    }) => {
      const res = await api.post("/user/add-user-booking-mapping-detail", body);
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useGetBookingInfo = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/booking/listBookingData", body);
      return res.data?.responseData?.response?.data?.[0]; // âœ… return only what you need
    },
    onSuccess: (data) => { },
  });
};

export const useQuotationEmail = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/fare_management/send-quotation-mail", body);
      return res.data?.responseData?.response?.data?.[0]; // âœ… return only what you need
    },
    onSuccess: (data) => {
      toast.success("Email sent successfully");
    },
  });
};
export const useQuotationSmS = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/fare_management/send-quotation-sms", body);
      return res.data?.sms; // âœ… return only what you need
    },
    onSuccess: (res) => {
      console.log("res", res);
      toast.success("SMS sent successfully");
    },
  });
};
export const useGetStatesByName = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/city/get-states-by-name", body);
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useUpdateDepartmentMutation = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const { id, ...rest } = body;
      const res = await api.put(`/user/department/update/${id}`, rest);
      return res?.data;
    },
  });
};

export const useDeleteDepartmentMutation = () => {
  return useMutation({
    mutationFn: async (id: number) => {
      const res = await api.delete(`/user/department/delete/${id}`);
      return res?.data;
    },
  });
};

export const useDepartmentByIdQuery = (id: number) => {
  return useQuery({
    queryKey: ["department", id],
    queryFn: async () => {
      const res = await api.get(`/user/department/get/${id}`);
      return res?.data;
    },
    enabled: !!id, // fetch only if id is provided
  });
};

export const useUpdateDepartmentStatus = () => {
  return useMutation({
    mutationFn: async (body: { id: number[]; status?: number }) => {
      const res = await api.post(
        "/user/department/update-user-status",
        body,
        {}
      );
      return res?.data?.responseData?.response;
    },
  });
};

export const useAddUserMutation = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/user/add-user", body);
      return res.data;
    },
    onSuccess: (data) => {
      // handle success if needed
    },
    onError: (error) => {
      console.error("Failed to add user:", error);
    },
  });
};

export const getAssignModuleByUserTypeId = () => {
  return useQuery({
    queryKey: ["modules"],
    queryFn: async () => {
      const res = await api.get(`/user/get-assign-module-by-user-type-id`);
      return res?.data?.data || [];
    },
  });
};

export const useGetBankDetails = () => {
  return useQuery({
    queryKey: ["bankDetails"],
    queryFn: async () => {
      const res = await api.get("/bankDetail/list");
      return res?.data?.responseData?.response?.data?.bankAccount;
    },
  });
};

export const useAddBankInfo = () => {
  return useMutation({
    mutationFn: (body: any) => api.post("/bankDetail/add", body, {}),
    onSuccess: (res) => {
      return true;
    },
  });
};
export const useGetUpdateUserDoc = () => {
  return useQuery({
    queryKey: ["UserDocu"],
    queryFn: async () => {
      const { data } = await api.get(`/userDocument/doc`);
      return data?.responseData?.response?.data?.docs;
    },
  });
};

export const useAddCardInfo = () => {
  return useMutation({
    mutationFn: (body: any) => api.post("/bankDetail/insert-card", body, {}),
    onSuccess: (res) => {
      return true;
    },
  });
};

export const useGetCardDetails = (user_id: number) => {
  return useQuery({
    queryKey: ["CardDetails"],
    queryFn: async () => {
      const res = await api.get(`/bankDetail/get-user-cards/${user_id}`);
      return res?.data?.data;
    },
  });
};
export const useGetUserInfo = (user_id: any) => {
  return useQuery({
    queryKey: ["UserInfo"],
    queryFn: async () => {
      const res = await api.get(`/user/get-user-info/${user_id}`);
      return res?.data?.data?.[0];
    },
  });
};

export const useUpdateUserProfile = () => {
  const user = useAuth();
  return useMutation({
    mutationFn: (body: any) =>
      api.put("user/user-info/" + body?.user_id, body, {}),
    onSuccess: () => {
      return true;
    },
  });
};

export const useUpdateProfile = () => {
  const user = useAuth();
  return useMutation({
    mutationFn: (body: any) => api.post("user/edit", body, {}),
    onSuccess: () => {
      return true;
    },
  });
};

export const useGetEditSignature = (user_id: any) => {
  return useQuery({
    queryKey: ["UserSignature", user_id],
    queryFn: async () => {
      try {
        const res = await api.get(`/user/signature/${user_id}`);
        return res?.data?.data || null;
      } catch (error: any) {
        // Handle 404 gracefully - signature doesn't exist yet
        if (error?.response?.status === 404) {
          return null;
        }
        // Re-throw other errors
        throw error;
      }
    },
    enabled: !!user_id, // Only fetch when user_id is available
    retry: false, // Don't retry on 404 errors
  });
};

export const useGetDutyInfo = (user_id: any) => {
  return useQuery({
    queryKey: ["ss"],
    queryFn: async () => {
      const res = await api.get(`user/duty-info/${user_id}`);
      return res?.data?.data;
    },
  });
};
export const useGetLanguageList = () => {
  return useQuery({
    queryKey: ["Lang"],
    queryFn: async () => {
      const res = await api.get(`lang/`);
      return res?.data?.data;
    },
  });
};
export const useGetPaymentTypeList = () => {
  return useQuery({
    queryKey: ["paymentType"],
    queryFn: async () => {
      const { data } = await api.get(`paymentType/`);
      console.log({ res: data?.data });
      return data?.responseData?.response?.data;
    },
  });
};
export const useGetShiftList = () => {
  return useQuery({
    queryKey: ["shift"],
    queryFn: async () => {
      const res = await api.get(`shift-list/`);
      return res?.data?.data;
    },
  });
};

export const useUpdateSignature = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post(`user/signature/${body?.user_id}`, body, {}),
    onSuccess: () => {
      return true;
    },
  });
};
export const useUpsertDutyInfo = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post(`user/duty-info/${body?.user_id}`, body, {}),
    onSuccess: () => {
      // returnx true;
      toast.success("Success");
    },
    onError: () => {
      toast.error("Error Updating");
    },
  });
};

export const useChangeStatus = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post(`user/status/${body?.user_id}`, body, {}),
    onSuccess: () => {
      toast.success("User Status Chnaged");
    },
  });
};

export const usePaymentUpload = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const { data } = await api.post(`/payment/advanceToVendor`, payload);
      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["paymentupload", variables.payload.user_id],
      });
    },
  });
};

export const useGetPaymentUploadList = (user_id: number) => {
  return useQuery({
    queryKey: ["useGetPaymentUploadList"],
    queryFn: async () => {
      const res = await api.get(`payment/uploadedPaymentList`, {
        params: { user_id },
      });
      return res?.data?.data;
    },
  });
};
export const useGetCoworkerList = () => {
  return useQuery({
    queryKey: ["coworker-list"],
    queryFn: async () => {
      const res = await api.get(`family/list`);
      return res?.data?.responseData?.response?.data?.list;
    },
  });
};

export const useAddCoworker = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const { data } = await api.post(`/family/add`, payload);
      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["coworker-list"],
      });
    },
  });
};

export const useUpdateCoworker = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const { data } = await api.put(`/family/update/${payload.id}`, payload);
      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["coworker-list"],
      });
    },
  });
};

export const useDeleteCoworker = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const { data } = await api.delete(`/family/delete/${payload}`);
      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["coworker-list"],
      });
    },
  });
};

export const useGetDriver = (id: any) => {
  return useQuery({
    queryKey: ["driver"],
    queryFn: async () => {
      const res = await api.get(`driver/get-driver/${id}`);
      return res?.data?.responseData?.response?.data?.list;
    },
  });
};

export const useUpateBranchStatus = () => {
  return useMutation({
    mutationFn: (body: any) => api.patch(`/company/branch/toggle`, body, {}),
    onSuccess: (res) => {
      // const companyData =res?.data?.responseData?.response?.data?.countryData;
      return true;
    },
  });
};

export const useGetUserCompanyInfo = () => {
  return useQuery({
    queryKey: ["userCompany"],
    queryFn: async () => {
      const res = await api.get(`/company/get-company-detail`);
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useGetAllStates = (state?: any) => {
  return useQuery({
    queryKey: ["allStates", state],
    queryFn: async () => {
      // Backend uses 'search' parameter, not 'state'
      // If state is provided and is a string with at least 2 chars, use it for filtering
      // Otherwise, fetch all states (no query parameter)
      const queryParam = state && typeof state === 'string' && state.length >= 2 
        ? `?search=${encodeURIComponent(state)}` 
        : '';
      const res = await api.get(`/all-states${queryParam}`);
      return res?.data?.data || [];
    },
    // Enable query if: no state provided (fetch all), or state is a string with at least 2 chars (filtered search)
    enabled: !state || (typeof state === 'string' && state.length >= 2),
  });
};

export const useUpdateLicenseDetails = () => {
  return useMutation({
    mutationFn: (body: any) => api.put("/driver/update-license", body, {}),
    onSuccess: (res) => {
      return true;
    },
  });
};

export const useGetDriverLicenseInfo = () => {
  return useQuery({
    queryKey: ["driverLicense"],
    queryFn: async () => {
      const res = await api.get("/driver/get-driver-details");
      console.log(res?.data?.responseData?.response?.message);
      return res?.data?.responseData?.response?.message;
    },
  });
};

export const useDeleteDriverDetails = () => {
  return useMutation({
    mutationFn: async () => {
      const res = await api.delete("/driver/delete-driver");
    },
    onSuccess: () => {
      return true;
    },
  });
};

export const useGetStatesbyCountryId = (country_id: number) => {
  return useQuery({
    queryKey: ["stateList"],
    queryFn: async () => {
      const res = await api.get("/states?country_id=" + country_id);
      return res.data.data;
    },
  });
};

export const useGetCitiesbyStateId = (state_id: number) => {
  return useQuery({
    queryKey: ["cityList"],
    queryFn: async () => {
      const res = await api.get("/city/cities?state_id=" + state_id);
      return res.data.data;
    },

    enabled: !!state_id,
  });
};

export const useGetKycRecordById = (kycId: number) => {
  useQuery({
    queryKey: ["kyc", kycId],
    queryFn: async () => {
      const res = await api.get(`/user/kyc/record/${kycId}`);
      return res.data;
    },
    enabled: !!kycId,
  });
};

export const useEditKyc = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ kycId, body }: { kycId: number; body: any }) => {
      if (!user?.id) throw new Error("User not logged in");
      const payload = { ...body };
      const res = await api.put(`/kyc/record/${kycId}`, payload);
      return res.data;
    },
    onSuccess: () => {
      // Invalidate the KYC list query to refresh the list
      if (user?.id) {
        queryClient.invalidateQueries({ queryKey: ["user", "kyc", user.id] });
      }
    },
  });
};

export const useDeleteKyc = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (kycId: number) => {
      if (!user?.id) throw new Error("User not logged in");
      const res = await api.delete(`user/kyc/record/${kycId}`);
      return res.data;
    },
    onSuccess: () => {
      // Invalidate the KYC list query to refresh the list
      if (user?.id) {
        queryClient.invalidateQueries({ queryKey: ["user", "kyc", user?.id] });
      }
    },
  });
};

export const useBankUserDetailList = () => {
  return useQuery({
    queryKey: ["bankUserDetailList"],
    queryFn: () => api.get("/bankDetail/list/"),
    select: (res) => res.data,
  });
};

export const useGetBankDetailsById = (id?: number) => {
  return useQuery({
    queryKey: ["bankDetails", id],
    queryFn: async () => {
      const res = await api.post("/bankDetail/get", { bankId: id });
      return res?.data?.responseData?.response?.data;
    },
    enabled: !!id,
  });
};

export const useUpdateBankDetails = (id: number) => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.put(`/bankDetail/update/${id}`, body, {});
      return res?.data?.responseData?.response;
    },
  });
};
export const useUpdateCompanyKycDetail = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: { id: number; payload: any }) => {
      const { data } = await api.patch(`/company/kyc_update/${id}`, payload);
      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["companykyc", variables.payload.user_id],
      });
    },
  });
};

export const useUpdateUserKyc = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: any) => {
      const payload = { ...body };

      const res = await api.post(`/user/kyc/${user?.id}`, payload);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["userKyc"],
      });
    },
  });
};

export const useGetKycUserInfo = () => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["userKyc"],
    queryFn: async () => {
      if (!user?.id) throw new Error("user not logged in ");
      const res = await api.get(`user/kyc/${user.id}`);
      return res.data.kycInfo;
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
  });
};

export const useViewKyc = () => {
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (kycId: number) => {
      if (!user?.id) throw new Error("User not logged in");
      const res = await api.get(`/kyc/record/${kycId}`);
      return res.data.kycInfo;
    },
  });
};

export const getFareDataArray = () => {
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (body: any) => {
      if (!user?.id) throw new Error("User not logged in");
      const res = await api.post(`/fare_management/getFareDataArray`, body);
      return res.data?.data;
    },
  });
};

export const getUserKycById = (kycId: number) => {
  return useQuery({
    queryKey: ["kyc", kycId],
    queryFn: async () => {
      const res = await api.get(`/user/kyc/record/${kycId}`);
      return res.data;
    },
    enabled: !!kycId,
  });
};

export const useUpdateCardDetails = () => {
  return useMutation({
    mutationFn: async ({ id, ...body }: any) => {
      const res = await api.put(`/user/card-update/${id}`, body, {});
      return res?.data?.responseData?.response;
    },
  });
};

export const useGetEmailTemplate = () => {
  return useMutation({
    mutationFn: (payload: any) => api.post("/user/get-template", { payload }),
    onSuccess: (res) => {
      const result = res?.data?.responseData?.response?.data;
      // console.log(result);
      return result;
    },
    onError: (err) => {
      console.error(MESSAGES.FAILED_FETCHED, err);
    },
  });
};

export const useGetEmailTemplates = () => {
  return useQuery({
    queryKey: ["emailTemplates"],
    queryFn: async () => {
      const res = await api.get("/email-template?includeInactive=true");
      let extracted: any[] = [];
      if (Array.isArray(res.data)) extracted = res.data;
      else if (Array.isArray(res.data?.data)) extracted = res.data.data;
      else if (Array.isArray(res.data?.templates)) extracted = res.data.templates;
      else if (typeof res.data === "object") extracted = Object.values(res.data);
      const normalizeActive = (value: any) => {
        if (value === undefined || value === null) return true;
        if (
          value === true ||
          value === 1 ||
          value === "1" ||
          value === "true"
        ) {
          return true;
        }
        return false;
      };

      const activeTemplates = extracted.filter((item: any) =>
        normalizeActive(item?.is_active ?? item?.isActive)
      );

      // Find templates with company_id = 1 that have header_text and footer_text
      const defaultTemplates = activeTemplates.filter((template: any) => {
        const templateCompanyId = template.company_id ?? template.companyId;
        return (
          (templateCompanyId === 1 || templateCompanyId === "1") &&
          (template.header_text?.trim() || template.footer_text?.trim())
        );
      });

      // Get default header_text and footer_text from company_id 1 templates
      let defaultHeaderText = "";
      let defaultFooterText = "";

      if (defaultTemplates.length > 0) {
        const templateWithHeader = defaultTemplates.find((t: any) =>
          t.header_text && t.header_text.trim()
        );
        if (templateWithHeader) {
          defaultHeaderText = templateWithHeader.header_text.trim();
        }

        const templateWithFooter = defaultTemplates.find(
          (t: any) => t.footer_text && t.footer_text.trim()
        );
        if (templateWithFooter) {
          defaultFooterText = templateWithFooter.footer_text.trim();
        }
      }

      // Update templates that don't have header_text or footer_text
      // Do this in the background without blocking the response
      if (defaultHeaderText || defaultFooterText) {
        activeTemplates.forEach(async (template: any) => {
          const templateId = template.id ?? template._id;
          const templateCompanyId = template.company_id ?? template.companyId;
          // Skip if template is from company_id 1 (already has the values)
          if (templateCompanyId === 1 || templateCompanyId === "1") {
            return;
          }

          // Check if template is missing header_text or footer_text
          const needsHeader =
            !template.header_text || !template.header_text.trim();
          const needsFooter =
            !template.footer_text || !template.footer_text.trim();

          if (
            (needsHeader && defaultHeaderText) ||
            (needsFooter && defaultFooterText)
          ) {
            try {
              const updateData: any = {};
              if (needsHeader && defaultHeaderText) {
                updateData.header_text = defaultHeaderText;
              }
              if (needsFooter && defaultFooterText) {
                updateData.footer_text = defaultFooterText;
              }

              // Update template in database
              await api.put(
                `/email-template/email-template/${templateId}`,
                updateData
              );
            } catch (error) {
              console.warn(
                `Failed to update template ${templateId} with default header/footer:`,
                error
              );
              // Continue with other templates
            }
          }
        });
      }
      return extracted.map((item: any) => ({
        id: item.id ?? item._id,
        name: item.name ?? item.title ?? "Untitled Template",
        type: item.type ?? "",
        header_text: item.header_text ?? "",
        description: item.description ?? "",
        footer_text: item.footer_text ?? "",
        isActive: normalizeActive(item?.is_active ?? item?.isActive),
      }));
    },
    enabled: true,
  });
};

export const useCreateEmailTemplate = () => {
  const queryClient = useQueryClient();
  const authStore = useAuth();

  return useMutation({
    mutationFn: async (body: {
      name: string;
      description: string;
      type?: string;
      header_text?: string;
      footer_text?: string;
    }) => {
      const user = authStore.user;
      const companyId = user?.company_id ?? 1; // fallback default if user has no company
      const userId = user?.id ?? 1;

      // Get all templates from API to find header_text and footer_text based on company_id
      let headerText = body.header_text?.trim() || "";
      let footerText = body.footer_text?.trim() || "";

      try {
        // Get all email templates
        const allTemplatesRes = await api.get("/email-template");
        let allTemplates: any[] = [];
        if (Array.isArray(allTemplatesRes.data)) allTemplates = allTemplatesRes.data;
        else if (Array.isArray(allTemplatesRes.data?.data)) allTemplates = allTemplatesRes.data.data;
        else if (Array.isArray(allTemplatesRes.data?.templates)) allTemplates = allTemplatesRes.data.templates;
        else if (typeof allTemplatesRes.data === "object") allTemplates = Object.values(allTemplatesRes.data);

        // Find templates that match the company_id
        const matchingTemplates = allTemplates.filter((template: any) => {
          const templateCompanyId = template.company_id ?? template.companyId;
          return (
            templateCompanyId === companyId ||
            templateCompanyId === Number(companyId)
          );
        });

        // Extract header_text and footer_text from matching templates
        if (matchingTemplates.length > 0) {
          // Find first template with header_text
          const templateWithHeader = matchingTemplates.find((t: any) =>
            t.header_text && t.header_text.trim()
          );
          if (templateWithHeader && !headerText) {
            headerText = templateWithHeader.header_text.trim();
          }

          // Find first template with footer_text
          const templateWithFooter = matchingTemplates.find((t: any) =>
            t.footer_text && t.footer_text.trim()
          );
          if (templateWithFooter && !footerText) {
            footerText = templateWithFooter.footer_text.trim();
          }
        }

        // If header_text or footer_text is still empty, fallback to company_id 1
        if (!headerText || !footerText) {
          const defaultTemplates = allTemplates.filter((template: any) => {
            const templateCompanyId = template.company_id ?? template.companyId;
            return templateCompanyId === 1 || templateCompanyId === "1";
          });

          if (defaultTemplates.length > 0) {
            if (!headerText) {
              const defaultTemplateWithHeader = defaultTemplates.find((t: any) =>
                t.header_text && t.header_text.trim()
              );
              if (defaultTemplateWithHeader) {
                headerText = defaultTemplateWithHeader.header_text.trim();
              }
            }

            if (!footerText) {
              const defaultTemplateWithFooter = defaultTemplates.find((t: any) =>
                t.footer_text && t.footer_text.trim()
              );
              if (defaultTemplateWithFooter) {
                footerText = defaultTemplateWithFooter.footer_text.trim();
              }
            }
          }
        }
      } catch (error) {
        console.warn("Failed to fetch templates for header/footer:", error);
        // Continue with provided values or empty strings
      }

      // Match backend model shape; keep HTML only in `description`
      const payload = {
        name: body.name,
        description: body.description, //  only HTML here
        company_id: companyId,
        type: body.type || "MASTER", // Use provided type or default to MASTER
        img: "",
        header_text: headerText,
        footer_text: footerText,
        created_by: userId,
        modified_by: userId,
        ip: "",
      };

      const res = await api.post("/email-template/email-template", payload);
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emailTemplates"] });
      toast.success("Template created successfully!");
    },
    onError: (err: any) => {
      console.error("Failed to create template:", err?.response?.data || err);
      toast.error("Failed to create template");
    },
  });
};

export const useUpdateEmailTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: {
      id: number;
      header_text?: string;
      description?: string;
      footer_text?: string;
      is_active?: boolean | number;
      isActive?: boolean;
    }) => {
      const { id, ...updateData } = body;
      const res = await api.put(
        `/email-template/email-template/${id}`,
        updateData
      );
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emailTemplates"] });
      toast.success("Template updated successfully!");
    },
    onError: (err) => {
      console.error("Failed to update template:", err);
      toast.error("Failed to update template");
    },
  });
};

export const useDeleteEmailTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const res = await api.delete(`/email-template/email-template/${id}`);
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emailTemplates"] });
      toast.success("Template deleted successfully!");
    },
    onError: (err) => {
      console.error("Failed to delete template:", err);
      toast.error("Failed to delete template");
    },
  });
};

export const useSendEmailWithAttachment = () => {
  return useMutation({
    mutationFn: (payload: any) =>
      api.post("/email/send-email-attachment", payload),
    onSuccess: (res) => {
      const result = res?.data?.responseData?.response?.data;
      toast.success("Email sent successfully!");
      return result;
    },
    onError: (err) => {
      console.error(MESSAGES.FAILED_FETCHED, err);
    },
  });
};

export const useVehicleTypesWithCount = (user_id?: number) => {
  return useQuery({
    queryKey: ["vehicleTypesWithCount", user_id],
    queryFn: async () => {
      if (!user_id) {
        throw new Error("User ID is required");
      }

      const url = `my-inventory/vehicle-types?user_id=${user_id}`;
      const res = await api.get(url);

      return res?.data?.data || [];
    },
    enabled: !!user_id && user_id > 0, // Only run query if valid user_id
    staleTime: 5 * 60 * 1000, // cache for 5 minutes
    retry: 1, //  retry once on failure
  });
};

export const useGetAllVehiclesTableData = () => {
  const { token } = useAuth();

  return useQuery({
    queryKey: ["allVehiclesTableData"],
    queryFn: async () => {
      const res = await api.get("/my-inventory/vehicles");
      console.log("all vehicles list data", res?.data);
      return res?.data?.data || [];
    },
    enabled: !!token, // Only run query if user is authenticated
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}


// export const useVehicleModels = (
//   vehicle_type_id?: number, 
//   vehicle_name?: string, 
//   enabled: boolean = true
// ) => {
//   return useQuery({
//     queryKey: ["vehicleModels", vehicle_type_id, vehicle_name],
//     queryFn: async () => {
//       const params: Record<string, any> = {};

//       if (vehicle_type_id !== undefined && vehicle_type_id !== null) {
//         params.vehicle_type_id = vehicle_type_id;
//       }

//       if (vehicle_name !== undefined && vehicle_name !== null && vehicle_name.trim() !== '') {
//         params.vehicle_name = vehicle_name.trim();
//       }

//       const res = await api.get("/my-inventory/unique-models", { params });
//       return res?.data?.data || [];
//     },
//     staleTime: 5 * 60 * 1000,
//     retry: 1,
//     enabled,
//   });
// };


export const useVehicleModels = (searchTerm?: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ["vehicleModels", searchTerm],
    queryFn: async () => {
      if (!searchTerm || searchTerm.trim().length < 3) {
        return [];
      }

      const params: Record<string, any> = {};

      // Use vehicle_name parameter, not vehicle_type_id
      if (searchTerm.trim() !== '') {
        params.vehicle_name = searchTerm.trim();
      }

      const res = await api.get("/my-inventory/unique-models", { params });
      return res?.data?.data || [];
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled: enabled && !!searchTerm && searchTerm.trim().length >= 3,
  });
};

export const useAddVehicle = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (vehicleData: any) => {
      // Expected: { model_name, model_type, vehicle_no, year_of_make }
      const res = await api.post("/my-inventory/add", vehicleData);
      console.log("Response for add vehicle:", res.data);
      return res.data;
    },

    onSuccess: (data) => {
      if (data.success) {
        toast.success(data.message || "Vehicle added successfully 🚗");

        // Refresh relevant queries (optional)
        queryClient.invalidateQueries({ queryKey: ["vehicleList"] });
        queryClient.invalidateQueries({ queryKey: ["vehicleModelsByType"] });
      } else {
        toast.warning(data.message || "Something went wrong.");
      }
    },

    onError: (error) => {
      // const message =
      //   error.response?.data?.message || "Failed to add vehicle ❌";
      // toast.error(message);
      console.error("Error adding vehicle:", error);
    },
  });
};

export const useAddVehicleWhileRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (vehicleData: any) => {
      // Expected: { model_name, model_type, vehicle_no, year_of_make }
      const res = await api.post("/my-inventory/add-while-registration", vehicleData);
      console.log("Response for add vehicle:", res.data);
      return res.data;
    },

    onSuccess: (data) => {
      if (data.success) {
        toast.success(data.message || "Vehicle added successfully 🚗");

        // Refresh relevant queries (optional)
        queryClient.invalidateQueries({ queryKey: ["vehicleList"] });
        queryClient.invalidateQueries({ queryKey: ["vehicleModelsByType"] });
      } else {
        toast.warning(data.message || "Something went wrong.");
      }
    },

    onError: (error) => {
      // const message =
      //   error.response?.data?.message || "Failed to add vehicle ❌";
      // toast.error(message);
      console.error("Error adding vehicle:", error);
    },
  });
};

export const useDeleteVehicles = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ids: number[]) => {
      if (!ids || ids.length === 0) {
        throw new Error("No vehicle IDs provided for deletion");
      }

      const res = await api.delete("/my-inventory/vehicles/delete", {
        data: { ids },
      });

      return res.data;
    },
    onSuccess: (data) => {
      toast.success(data?.message || "Vehicles deleted successfully");

      queryClient.invalidateQueries({ queryKey: ["vehicles"] });
    },
    onError: (error: any) => {
      console.error("Error deleting vehicles:", error);
      toast.error(
        error?.response?.data?.message || "Failed to delete vehicles"
      );
    },
  });
};

export const useaddNewsletter = (onSuccessCallback?: () => void) => {
  return useMutation({
    mutationFn: async (body: any) => {
      const response = await api.post("/newsletter/create", body);
      return response.data;
    },
    onSuccess: () => {
      if (onSuccessCallback) onSuccessCallback();
      toast.success("Newsletter created successfully!");
    },
  });
};

export const useDeleteNewsletter = (onSuccessCallback?: () => void) => {
  return useMutation({
    mutationFn: async (id: any) => {
      const res = await api.put("/newsletter/delete-user", { id });
      return res?.data?.responseData?.response?.data?.result;
    },
    onSuccess: () => {
      toast.success("Newsletter Deleted succesfully!");
      if (onSuccessCallback) onSuccessCallback();
    },
  });
};

export const useGetNewsletters = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const response = await api.post("/newsletter/all-users", body);
      return response?.data?.responseData?.response?.data;
    },
  });
};

// Hook to fetch newsletter users by filters (similar to useFetchUsersByFilters but for newsletter users)
export const useFetchNewsletterUsersByFilters = () => {
  const { token } = useAuth();

  return useMutation({
    mutationFn: async ({
      user_type_id,
      state_id,
      city_id,
      company_id,
      limit = 200,
      page = 1,
      email_subscription,
      mobile_subscription,
    }: {
      user_type_id: string | number | (string | number)[];
      state_id?: string | number;
      city_id?: string | number;
      company_id?: string | number;
      limit?: number;
      page?: number;
      email_subscription?: string;
      mobile_subscription?: string;
    }) => {
      const body: any = {};

      // Handle user_type_id as array or single value
      if (user_type_id) {
        if (Array.isArray(user_type_id)) {
          body.user_type_id = user_type_id.map(id => Number(id));
        } else {
          body.user_type_id = Number(user_type_id);
        }
      }

      // Backend expects 'state' not 'state_id'
      if (state_id) body.state = Number(state_id);
      if (city_id) body.city_id = Number(city_id);
      if (company_id) body.company_id = Number(company_id);
      if (email_subscription) body.email_subscription = email_subscription;
      if (mobile_subscription) body.mobile_subscription = mobile_subscription;
      
      // Backend expects 'pageNumber' not 'page'
      body.pageNumber = page;
      body.limit = limit;

      const res = await api.post("/newsletter/all-users", body, {
        headers: token
          ? {
            Authorization: `Bearer ${token}`,
          }
          : undefined,
      });

      // Backend returns: { data: users, pagination: {...} }
      // Wrapped in successResponse structure
      // If no users found, backend returns errorResponse, so check for error first
      if (res?.data?.status === "error" || res?.data?.success === false) {
        // No users found or error - return empty array
        return [];
      }

      const response = res?.data?.responseData?.response;
      const responseData = response?.data;
      
      // Extract users array from nested structure
      // Structure: res.data.responseData.response.data.data (users array)
      const usersArray = responseData?.data;
      const nestedUsers = responseData?.users;
      const fallbackData = res?.data?.data;

      if (Array.isArray(response)) return response;
      if (Array.isArray(usersArray)) return usersArray;
      if (Array.isArray(nestedUsers)) return nestedUsers;
      if (Array.isArray(responseData)) return responseData;
      if (Array.isArray(fallbackData)) return fallbackData;

      return [];
    },
  });
};



export const useUpateNewsletterStatus = () => {
  return useMutation({
    mutationFn: (body: any) => api.put("/newsletter/update-status", body, {}),
    onSuccess: (res) => {
      toast.success("Newsletter Updated Succesfullly!");
      return true;
    },
  });
};

export const useUpdateNewsletter = (onSuccessCallback?: () => void) => {
  return useMutation({
    mutationFn: (body: any) => api.put("/newsletter/update", body, {}),
    onSuccess: () => {
      toast.success("Newsletter Updated succesfully!");
      if (onSuccessCallback) onSuccessCallback();
      return true;
    },
  });
};

export const useUpdateNewsletterSubscribeMobile = (
  onSuccessCallback?: () => void
) => {
  return useMutation({
    mutationFn: (body: any) =>
      api.put("/newsletter/subscribe-mobile", body, {}),
    onSuccess: () => {
      toast.success("Newsletter Mobile Subscribed!");
      if (onSuccessCallback) onSuccessCallback();
      return true;
    },
  });
};

export const useUpdateNewsletterUnsubscribeMobile = (
  onSuccessCallback?: () => void
) => {
  return useMutation({
    mutationFn: (body: any) =>
      api.put("/newsletter/unsubscribe-mobile", body, {}),
    onSuccess: () => {
      toast.success("Newsletter Mobile Unsubscribed!");
      if (onSuccessCallback) onSuccessCallback();
      return true;
    },
  });
};

export const useUpdateNewsletterSubscribeEmail = (
  onSuccessCallback?: () => void
) => {
  return useMutation({
    mutationFn: (body: any) => api.put("/newsletter/subscribe-email", body, {}),
    onSuccess: () => {
      toast.success("Newsletter Email Subscribed!");
      if (onSuccessCallback) onSuccessCallback();
      return true;
    },
  });
};

export const useUpdateNewsletterUnsubscribeEmail = (
  onSuccessCallback?: () => void
) => {
  return useMutation({
    mutationFn: (body: any) =>
      api.put("/newsletter/unsubscribe-email", body, {}),
    onSuccess: () => {
      toast.success("Newsletter Email Unsubscribed!");
      if (onSuccessCallback) onSuccessCallback();
      return true;
    },
  });
};

export const useCreateCampaignMaster = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/campaign-master", body);
      return res?.data;
    },
  });
};

export const useGetAllCampaigns = () => {
  return useQuery({
    queryKey: ["campaigns"],
    queryFn: async () => {
      const res = await api.get("/campaign-master/get-campaigns");
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useCreateNewsletterComment = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/newsletter-comment", body);
      console.log(res?.data?.data);
      return res?.data?.data;
    },
  });
};

export const useGetNewsletterComments = (newsletterId: number) => {
  return useQuery({
    queryKey: ["newsletterComments", newsletterId],
    queryFn: async () => {
      const res = await api.get(`/newsletter-comment/${newsletterId}`);
      return res?.data?.data;
    },
    enabled: !!newsletterId,
  });
};

export const useGetNewsletterCommentById = (commentId: number) => {
  return useQuery({
    queryKey: ["newsletterComment", commentId],
    queryFn: async () => {
      const res = await api.get(`/newsletter-comment/${commentId}`);
      return res?.data?.responseData?.response?.data;
    },
    enabled: !!commentId,
  });
};

export const useUpdateComment = (id: any) => {
  return useMutation({
    mutationFn: async () => {
      const res = await api.put("/newsletter-comment", id);
      return res?.data;
    },
  });
};

export const useDeleteNewsletterComment = () => {
  return useMutation({
    mutationFn: async (id: any) => {
      const res = await api.delete("/newsletter-comment", id);
    },
    onSuccess: () => {
      toast.success("Comment Deleted Successfully");
    },
  });
};

export const useCreateChat = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/chat/create", body);
      console.log(res?.data?.data);
      return res?.data?.data;
    },
  });
};

export const useGetAllChats = () => {
  return useQuery({
    queryKey: ["chats"],
    queryFn: async () => {
      const res = await api.get(`/chat/list`);
      return res?.data?.responseData?.response?.data;
    },
  });
};

export const useGetChatById = (chatId: number) => {
  return useQuery({
    queryKey: ["newsletterComment", chatId],
    queryFn: async () => {
      const res = await api.get(`/chat/detail/${chatId}`);
      return res?.data?.responseData?.response?.data;
    },
    enabled: !!chatId,
  });
};

export const useUpdateChat = (id: any) => {
  return useMutation({
    mutationFn: async () => {
      const res = await api.put("/chat/update", id);
      return res?.data;
    },
  });
};

export const useDeleteChat = (id: any) => {
  return useMutation({
    mutationFn: async () => {
      const res = await api.delete("/chat/delete", id);
      return res?.data;
    },
  });
};

export const useGetMessagesByChatId = (chatId: number) => {
  return useQuery({
    queryKey: ["messages", chatId],
    queryFn: async () => {
      const res = await api.get(`/chat/messages/${chatId}`);
      // console.log(res?.data?.responseData?.response?.data);
      return res?.data?.responseData?.response?.data;
    },
    enabled: !!chatId,
  });
};

export const useGetTourInclusionDetails = () => {
  return useQuery({
    queryKey: ["tourInclusionDetails"],
    queryFn: async () => {
      // Backend route: app.use("/api/tour-inclusion", masterTourInclusionRoute);
      // Route file: router.post('/get-tour-inclusion-details', ...)
      const res = await api.post("/tour-inclusion/get-tour-inclusion-details", {});
      // Controller returns: { status: "success", data: [...] } or 404 with status/message
      return res?.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

// Tour Category hooks
export const useGetTourCategories = () => {
  return useQuery({
    queryKey: ["tourCategories"],
    queryFn: async () => {
      // Backend route: app.use("/api/tour-category", masterTourCategoryRoute);
      // Active list endpoint
      const res = await api.post("/tour-category/get-active-tour-categories", {});
      // Controller returns: { status: "success", data: [...] }
      return res?.data?.data || [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

// Get active hotel categories for dropdown
export const useGetActiveHotelCategories = () => {
  return useQuery({
    queryKey: ["hotelCategories"],
    queryFn: async () => {
      // Backend route: app.use("/api/hotel-category", masterHotelCategoryRoute);
      // Active list endpoint
      const res = await api.post("/hotel-category/get-active-hotel-categories", {});
      // Controller returns: { status: "success", data: [...] }
      return res?.data?.data || res?.data?.responseData?.response?.data || [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFareListData = () => {
  return useMutation({
    mutationFn: async (payload: {
      limit?: string;
      sort_column?: string;
      sort_order?: string;
      searchValue?: string;
      city_id?: string;
    }) => {
      const res = await api.post("/fare_management/get_fare_list_data", payload);
      return res?.data;
    },
  });
};

export const useAddTourInclusionDetails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/tour-inclusion/add-tour-inclusion-details",
        payload
      );
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tourInclusionDetails"] });
    },
  });
}

// Tour Detail Hooks
export const useAddTourDetail = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/tour-detail/add-tour-detail", payload);
      return res?.data;
    },
    onSuccess: () => {
      toast.success("Tour detail added successfully!");
    },
    onError: (error: any) => {
      const message = error?.response?.data?.message || "Failed to add tour detail";
      toast.error(message);
    }
  });
};

export const useUpdateTourDetail = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/tour-detail/update-tour-detail", payload);
      return res?.data;
    },
    onSuccess: () => {
      toast.success("Tour detail updated successfully!");
    },
    onError: (error: any) => {
      const message = error?.response?.data?.message || "Failed to update tour detail";
      toast.error(message);
    }
  });
};

export const useGetTourDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/tour-detail/get-tour-details", payload);
      return res?.data;
    }
  });
};

export const useGetTourDetailById = (id?: number) => {
  return useQuery({
    queryKey: ["tourDetail", id],
    queryFn: async () => {
      const res = await api.get(`/tour-detail/get-tour-detail/${id}`);
      return res?.data;
    },
    enabled: !!id,
  });
};

//Campaign Management Hooks
export const useGetCampaigns = (company_id?: number) => {
  const { user } = useAuth();
  const companyId = company_id || user?.company_id;

  return useQuery({
    queryKey: ["campaigns", companyId],
    queryFn: async () => {
      const res = await api.get("/campaign-master/get-campaigns", {
        params: { company_id: companyId },
      });

      return res?.data?.data || [];
    },
    enabled: !!companyId,
  });
};

export const useCreateCampaign = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: {
      campaign_name: string;
      list_id: number | number[] | null;
      template_id?: number;
      user_ids?: number[];
      user_type_id?: number | number[];
      scheduled_date?: string;
      launch_status?: string;
      generate_url?: string;
      launch_date?: string | string[];
      recipients?: number;
      company_id?: number; // Allow company_id to be passed explicitly
      cron_days?: string; // Comma separated days (e.g., "1,2,3")
      before_after?: string; // "0" for before, "1" for after, or comma-separated
    }) => {
      // Get company_id from body first, then user, with validation
      const companyId = body.company_id || user?.company_id;
      if (!user?.id) {
        throw new Error("User not logged in. Please login again.");
      }

      if (!companyId || companyId === 0) {
        console.error("Company ID missing:", {
          fromBody: body.company_id,
          fromUser: user?.company_id,
          user: user
        });
        throw new Error(
          "Company ID is required. Please ensure you are associated with a company."
        );
      }

      // Handle list_id as array or single value
      let listIdValue: number[] | null = null;
      if (body.list_id !== null && body.list_id !== undefined) {
        listIdValue = Array.isArray(body.list_id)
          ? body.list_id.map(id => Number(id)).filter(id => !isNaN(id))
          : [Number(body.list_id)].filter(id => !isNaN(id));
        if (listIdValue.length === 0) listIdValue = null;
      }

      // Handle user_type_id as array or single value
      let userTypeIdValue: number[] | undefined = undefined;
      if (body.user_type_id !== undefined && body.user_type_id !== null) {
        userTypeIdValue = Array.isArray(body.user_type_id)
          ? body.user_type_id.map(id => Number(id)).filter(id => !isNaN(id) && id > 0)
          : [Number(body.user_type_id)].filter(id => !isNaN(id) && id > 0);
        if (userTypeIdValue.length === 0) userTypeIdValue = undefined;
      }

      // Handle launch_date - can be array (for multiple campaigns) or single value
      let launchDateValue: string | string[] | null = null;
      if (body.launch_date !== undefined && body.launch_date !== null) {
        if (Array.isArray(body.launch_date)) {
          const filtered = body.launch_date.filter(date => date !== null && date !== undefined && date !== "");
          launchDateValue = filtered.length > 0 ? filtered : null;
        } else {
          launchDateValue = body.launch_date !== "" ? body.launch_date : null;
        }
      }

      const payload: Record<string, any> = {
        company_id: Number(companyId), // Ensure it's a number
        campaign_name: body.campaign_name,
        list_id: listIdValue || [],
        template_id: body.template_id || 1,
        user_ids: body.user_ids || [],
        created_by: Number(user.id),
        scheduled_date: body.scheduled_date || null,
        launch_status: body.launch_status || "Pending", // Model expects: "Pending", "Scheduled", "Launched", "Failed"
        generate_url: body.generate_url || null,
        launch_date: launchDateValue, // Backend will create multiple campaigns if this is an array
        recipients: body.recipients || 0,
      };

      // Include user_type_id if provided
      if (userTypeIdValue && userTypeIdValue.length > 0) {
        payload.user_type_id = userTypeIdValue;
      }

      // Include cron_days and before_after if provided
      if (body.cron_days && body.cron_days.trim() !== "") {
        payload.cron_days = body.cron_days.trim();
      }
      if (body.before_after && body.before_after.trim() !== "") {
        payload.before_after = body.before_after.trim();
      } else if (body.before_after === undefined) {
        // If not provided, use default "0"
        payload.before_after = "0";
      }

      console.log("Creating campaign with payload:", payload);

      // Route is /campaign-master/ (POST) not /campaign-master/create
      const res = await api.post("/campaign-master/", payload);
      // Backend returns: { success: true, message: "...", data: campaignData }
      if (res?.data?.success) {
        return res.data.data || res.data;
      }
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
      // Toast message handled in component to show count
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.message || "Failed to create campaign";
      toast.error(message);
      console.error("Campaign creation error:", error);
      console.error("Error response:", error?.response?.data);
    },
  });
};

export const useUpdateTourInclusionDetails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/tour-inclusion/update-tour-inclusion-details",
        payload
      );
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tourInclusionDetails"] });
    },
  });
};

export const useTourInclusionStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/tour-inclusion/tour-inclusion-status",
        payload
      );
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tourInclusionDetails"] });
    },
  });
};

export const useTourBookingType = () => {
  return useQuery({
    queryKey: ["tourBookingType"],
    queryFn: async () => {
      // Backend route: /api/tour-booking-type (GET)
      // Controller returns: { success: true, data: tourTypes }
      const res = await api.get("/tour-booking-type");
      // Extract the response - controller returns { success: true, data: [...] }
      // Return the full response object so component can access .data property
      return res?.data || {};
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useDeleteTourInclusions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { id: string; user_id: number }) => {
      const res = await api.delete("/tour-inclusion/delete-tour-inclusions", {
        data: payload,
      });
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tourInclusionDetails"] });
    },
  });
};

export const useGetTourExclusionDetails = () => {
  return useQuery({
    queryKey: ["tourExclusionDetails"],
    queryFn: async () => {
      const res = await api.get("/tour_management/gettourexclusionDetails");
      return res?.data?.responseData?.response;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useAddTourExclusionDetails = () => {
  return useMutation({
    mutationKey: ["addTourExclusion"],
    mutationFn: async (payload: any) => {
      const res = await api.post("/tour-exclusion/add-tour-exclusion-details", payload);
      return res?.data;
    },
  });
};

export const useUpdateTourExclusionDetails = () => {
  return useMutation({
    mutationKey: ["updateTourExclusion"],
    mutationFn: async (payload: any) => {
      const res = await api.post("/tour-exclusion/update-tour-exclusion-details", payload);
      return res?.data;
    },
  });
};

export const useTourExclusionStatus = () => {
  return useMutation({
    mutationKey: ["tourExclusionStatus"],
    mutationFn: async (payload: { id: string; user_id: number; status: number }) => {
      const res = await api.put("/tour-exclusion/tour-exclusion-status", payload);
      return res?.data;
    },
  });
};
export const useDeleteTourExclusions = () => {
  return useMutation({
    mutationKey: ["deleteTourExclusion"],
    mutationFn: async (payload: { id: string; user_id: number }) => {
      const res = await api.delete("/tour-exclusion/delete-tour-exclusions", {
        data: payload,
      });
      return res?.data;
    },
  });
};

// tour type

export const useGetTourTypeTheme = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/tour-theme/get-tour-themes", payload);
      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// Parking charge for activities
export const useAddParkingCharge = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/parking-charge/add", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// Guide charge for activities
export const useAddGuideCharge = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/guide-fare/add", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useGetActiveTourThemes = () => {
  return useMutation({
    mutationFn: async (payload: any = {}) => {
      const res = await api.post("/tour-theme/get-active-tour-themes", payload);
      return res?.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddTourTheme = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/tour-theme/add-tour-theme", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateTourTheme = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/tour-theme/update-tour-theme", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const updateTourThemeStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/tour-theme/update-tour-theme-status",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useDeleteTourThemes = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.delete("/tour-theme/delete-tour-themes", {
        data: payload,
      });

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// master address

export const useGetAddresses = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/adress/get-addresses", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddAddress = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/adress/add-address", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateAddress = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/adress/update-address", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useDeleteAddresses = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.delete("/adress/delete-addresses", {
        data: payload,
      });

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// master location

export const useGetLocations = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/location/get-locations", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddLocation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/location/add-location", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateLocation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/location/update-location", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useSearchLocations = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/location/search-locations", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};



export const useDeleteLocations = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.delete("/location/delete-locations", {
        data: payload,
      });

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// master modules

export const getModuleListNested = (usertype_id: number) => {
  return useQuery({
    queryKey: ["modulesnested"],
    queryFn: async () => {
      const res = await api.get(
        `/module-master/modules/nested?usertype_id=${usertype_id}`
      );
      return res?.data?.responseData?.response?.data;
    },
    enabled: !!usertype_id,
  });
};

export const useGetModuleById = (id: number) => {
  return useQuery({
    queryKey: ["moduleById"],
    queryFn: async () => {
      const res = await api.get(`/module-master/modules/detail/${id}`);
      return res?.data?.responseData?.response?.data;
    },
    enabled: !!id,
  });
};

export const useUpdateModule = () => {
  return useMutation({
    mutationFn: async ({ id, payload }: any) => {
      const res = await api.put(`/module-master/modules/update/${id}`, payload);
      return res.data?.responseData?.response?.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useSavePermission = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/module-master/permissions/save", payload);
      return res.data?.responseData?.response?.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useSaveBulkPermissions = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/module-master/permissions/bulk", payload);
      return res.data?.responseData?.response?.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useGetPermissionsByUsertype = (usertype_id: number) => {
  return useQuery({
    queryKey: ["permissions-module"],
    queryFn: async () => {
      const res = await api.get(`/module-master/permissions/${usertype_id}`);
      return res?.data?.responseData?.response?.data;
    },
    enabled: !!usertype_id,
  });
};

// export const useSendMessage = () => {
//   return useMutation({
//     mutationFn: (body: any) =>
//       api.post("/chat/messages", body, {}),
//     onSuccess: (res) => {
//       console.log(res?.data);
//     }
// export const useGetCampaignLists = () => {
//   return useQuery({
//     queryKey: ["campaignLists"],
//     queryFn: async () => {
//       const res = await api.get("/campaign-master/get-campaigns");
//       return res?.data?.data || [];
//     },
//     enabled: true,
//   });
// };

export const useGetCampaignLists = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["campaignLists", user?.company_id],
    queryFn: async () => {
      if (!user?.company_id) {
        throw new Error("company_id missing — please login again.");
      }

      const res = await api.get("/campaign-master/get-campaigns", {
        params: { company_id: user.company_id },
      });

      return res?.data?.data || [];
    },
    enabled: !!user?.company_id,
  });
};

// Get single campaign by ID
export const useGetSingleCampaign = () => {
  return useMutation({
    mutationFn: async (id: number) => {
      const res = await api.get("/campaign-master", {
        params: { id },
      });

      const raw = res?.data;
      const legacy =
        raw?.responseData?.response?.data ||
        raw?.responseData?.response ||
        raw?.responseData;

      if (legacy?.campaign) return legacy.campaign;
      if (legacy) return legacy;

      if (raw?.data?.campaign) return raw.data.campaign;
      if (raw?.data) return raw.data;

      if (raw?.campaign) return raw.campaign;

      return raw;
    },
  });
};

// Get campaign email logs
export const useGetCampaignEmailLogs = () => {
  return useMutation({
    mutationFn: async (campaign_id: number) => {
      const res = await api.get("/campaign-master/email-logs", {
        params: { campaign_id },
      });

      return res?.data?.responseData?.response?.data || res?.data?.data || res?.data;
    },
  });
};

// Update campaign
export const useUpdateCampaign = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: {
      id: number;
      campaign_name?: string;
      list_id?: number | number[] | null;
      template_id?: number;
      user_ids?: number[];
      user_type_id?: number | number[];
      scheduled_date?: string;
      launch_status?: string;
      generate_url?: string;
      launch_date?: string | string[];
      recipients?: number;
    }) => {
      if (!user?.id) {
        throw new Error("User not logged in. Please login again.");
      }

      const payload: Record<string, any> = {
        id: body.id,
      };

      if (body.campaign_name) {
        payload.campaign_name = body.campaign_name;
      }

      // Handle list_id as array or single value
      if (body.list_id === null) {
        payload.list_id = null;
      } else if (body.list_id !== undefined) {
        if (Array.isArray(body.list_id)) {
          payload.list_id = body.list_id.map(id => Number(id)).filter(id => !isNaN(id));
        } else {
          payload.list_id = [Number(body.list_id)].filter(id => !isNaN(id));
        }
      }

      if (body.template_id) {
        payload.template_id = Number(body.template_id);
      }

      if (body.user_ids) {
        payload.user_ids = body.user_ids;
      }

      // Handle user_type_id as array or single value
      if (body.user_type_id !== undefined && body.user_type_id !== null) {
        if (Array.isArray(body.user_type_id)) {
          payload.user_type_id = body.user_type_id.map(id => Number(id)).filter(id => !isNaN(id) && id > 0);
        } else {
          const numId = Number(body.user_type_id);
          if (!isNaN(numId) && numId > 0) {
            payload.user_type_id = [numId];
          }
        }
      }

      if (body.scheduled_date !== undefined) {
        payload.scheduled_date = body.scheduled_date || null;
      }

      if (body.launch_status) {
        payload.launch_status = body.launch_status;
      }

      if (body.generate_url !== undefined) {
        payload.generate_url = body.generate_url || null;
      }

      // Handle launch_date - for update, use single value (first from array if array provided)
      if (body.launch_date !== undefined) {
        if (Array.isArray(body.launch_date) && body.launch_date.length > 0) {
          payload.launch_date = body.launch_date[0] || null;
        } else {
          payload.launch_date = body.launch_date || null;
        }
      }

      if (body.recipients !== undefined) {
        payload.recipients = body.recipients || 0;
      }

      console.log("Updating campaign with payload:", payload);
      const res = await api.put("/campaign-master/", payload);

      if (res?.data?.success) {
        return res.data.data || res.data;
      }
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
      toast.success("Campaign updated successfully!");
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.message || "Failed to update campaign";
      toast.error(message);
      console.error("Campaign update error:", error);
    },
  });
};

// Delete campaign
export const useDeleteCampaign = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number | string) => {
      const numericId = Number(id);
      const res = await api.delete("/campaign-master/", {
        data: { id: numericId },
      });
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
      toast.success("Campaign deleted successfully!");
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.message || "Failed to delete campaign";
      toast.error(message);
      console.error("Campaign delete error:", error);
    },
  });
};

// Get lists based on user_ids
export const useGetListsByUserIds = () => {
  return useMutation({
    mutationFn: async (user_ids: number[]) => {
      if (!user_ids || user_ids.length === 0) {
        return [];
      }
      // Adjust endpoint based on your API
      const res = await api.post("/user", { user_ids });
      return res?.data?.responseData?.response?.data || [];
    },
  });
};

// Get templates based on user_ids
export const useGetTemplatesByUserIds = () => {
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (user_ids: number[]) => {
      if (!user_ids || user_ids.length === 0) {
        return [];
      }
      // Get templates filtered by company_id (users belong to company)
      const res = await api.get("/email-template", {
        params: { company_id: user?.company_id },
      });
      let extracted: any[] = [];
      if (Array.isArray(res.data)) extracted = res.data;
      else if (Array.isArray(res.data?.data)) extracted = res.data.data;
      else if (Array.isArray(res.data?.templates)) extracted = res.data.templates;
      else if (typeof res.data === "object") extracted = Object.values(res.data);
      return extracted
        .filter((item: any) => {
          const flag = item?.is_active ?? item?.isActive;
          return flag !== false;
        })
        .map((item: any) => ({
          id: item.id ?? item._id,
          name: item.name ?? item.title ?? "Untitled Template",
          type: item.type ?? "",
        }));
    },
  });
};

export const useSendMessage = () => {
  return useMutation({
    mutationFn: (body: any) => api.post("/chat/messages", body),

    onSuccess: (res) => {
      console.log(res?.data);
    },

    onError: (err) => {
      console.error(err);
    },
  });
};

// master local package

export const useGetLocalPackages = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/local-package/get-local-packages", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddLocalPackage = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/local-package/add-local-package", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateLocalPackage = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/local-package/update-local-package",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateMasterLocalPackageStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/local-package/update-local-package-status",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};


export const useDeleteLocalPackages = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.delete("/local-package/delete-local-packages", {
        data: payload,
      });

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// get package booking type and booking mode

export const useGetBookingTypesAndModes = () => {
  return useQuery({
    queryKey: ["wallet"],
    queryFn: async () => {
      const res = await api.get("/local-package/get-booking-types-modes");
      return res.data;
    },
    enabled: true,
  });
};

// master payment structure details

export const useGetPaymentStructureDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/payment-structure/get-payment-structure-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddPaymentStructureDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/payment-structure/add-payment-structure-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdatePaymentStructureDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/payment-structure/update-payment-structure-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const usePaymentStructureStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/payment-structure/payment-structure-status",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// booking types

export const useGetAllBookingTypes = () => {
  return useQuery({
    queryKey: ["bookingTypes"],
    queryFn: async () => {
      const res = await api.get("/booking-type/all-booking-types");
      return res.data;
    },
  });
};

// master cancellation

export const useGetCancellationPolicyDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/cancellation-policy/get-cancellation-policy-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddCancellationPolicyDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/cancellation-policy/add-cancellation-policy-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateCancellationPolicyDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/cancellation-policy/update-cancellation-policy-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useCancellationPolicyStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/cancellation-policy/cancellation-policy-status",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// master refund policy

export const useGetRefundPolicyDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/refund-policy/get-refund-policy-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddRefundPolicyDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/refund-policy/add-refund-policy-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateRefundPolicyDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/refund-policy/update-refund-policy-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useRefundPolicyStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/refund-policy/refund-policy-status", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// master terms and condition

export const useGetTermConditionsDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/terms-condition-policy/get-term-conditions-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddTermConditionsDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/terms-condition-policy/add-term-conditions-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateTermConditionsDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/terms-condition-policy/update-term-conditions-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useTermConditionsPolicyStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/terms-condition-policy/term-conditions-policy-status",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// master transfer



// master transfer 

export const useGetTransferDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/transfer/get-transfer-details", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddTransferDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/transfer/add-transfer-details", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateTransferDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/transfer/update-transfer-details", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useTransferStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/transfer/transfer-status", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useTransferImageUpload = (
  onSuccessCallback?: (filePath: string, url: string) => void,
  onErrorCallback?: (error: any) => void
) => {
  return useMutation({
    mutationFn: async (file: File) => {
      console.log("🚀 Starting image upload mutation...", {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
      });

      const formData = new FormData();
      formData.append("thumb_image", file);

      // Add folder as query parameter
      const res = await api.post(
        "/transfer/upload-image?folder=transfer_master",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("📥 Upload response:", res.data);

      if (res.data.status === "success") {
        // Return both filePath and url from response
        return {
          filePath: res.data.data.filePath,
          url: res.data.data.url,
        };
      } else {
        throw new Error(res.data.message || "Failed to upload image");
      }
    },
    onSuccess: (data) => {
      console.log("✅ Image upload successful:", data);
      if (onSuccessCallback) {
        onSuccessCallback(data.filePath, data.url);
      }
    },
    onError: (error: any) => {
      console.error("❌ Image upload failed:", error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    },
  });
};

// master city activity
// master activity list
export const useGetCityActivityDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/activity/get-city-activity-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// city activity by city id
// export const useGetCityActivitiesByCityId = (cityId: string) => {
//   return useMutation({
//     mutationFn: async () => {
//       const res = await api.get(`/activity/get-city-activities/${cityId}`);
//       console.log(res.data);

//       return res.data;
//     },
//     onError: (err) => {
//       console.error("error", err);
//     },
//   });
// };


export const useAddCityActivityDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/activity/add-city-activity-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateCityActivityDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/activity/update-city-activity-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useCityActivityStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/activity/city-activity-status", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useGetActivityFare = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/activity/get-activity-fare", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useCityActivityImageUpload = (
  onSuccessCallback?: (filePath: string, url: string) => void,
  onErrorCallback?: (error: any) => void
) => {
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append("thumb_image", file);

      // Add folder as query parameter
      const res = await api.post(
        "/transfer/upload-image?folder=city_activity",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status === "success") {
        // Return both filePath and url from response
        return {
          filePath: res.data.data.filePath,
          url: res.data.data.url,
        };
      } else {
        throw new Error(res.data.message || "Failed to upload image");
      }
    },
    onSuccess: (data) => {
      console.log(" Image upload successful:", data);
      if (onSuccessCallback) {
        onSuccessCallback(data.filePath, data.url);
      }
    },
    onError: (error: any) => {
      console.error(" Image upload failed:", error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    },
  });
};

// master documentation

export const useGetMasterDocumentation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/documentation/get-documentation-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddDocumentationDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/documentation/add-documentation-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateDocumentationDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/documentation/update-documentation-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useDocumentationStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/documentation/documentation-status", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

// master city introduction

export const useGetCityIntroductionDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/city-introduction/get-city-introduction-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddCityIntroductionDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/city-introduction/add-city-introduction-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateCityIntroductionDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/city-introduction/update-city-introduction-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useCityIntroductionStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/city-introduction/city-introduction-status",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useCityIntroductionImageUpload = (
  onSuccessCallback?: (filePath: string, url: string) => void,
  onErrorCallback?: (error: any) => void
) => {
  return useMutation({
    mutationFn: async (file: File) => {
      console.log("🚀 Starting image upload mutation...", {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
      });

      const formData = new FormData();
      formData.append("thumb_image", file);

      // Add folder as query parameter
      const res = await api.post(
        "/transfer/upload-image?folder=city_introduction",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("📥 Upload response:", res.data);

      if (res.data.status === "success") {
        // Return both filePath and url from response
        return {
          filePath: res.data.data.filePath,
          url: res.data.data.url,
        };
      } else {
        throw new Error(res.data.message || "Failed to upload image");
      }
    },
    onSuccess: (data) => {
      console.log("✅ Image upload successful:", data);
      if (onSuccessCallback) {
        onSuccessCallback(data.filePath, data.url);
      }
    },
    onError: (error: any) => {
      console.error("❌ Image upload failed:", error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    },
  });
};

// master airport railway

export const useAddAirportRailway = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/airport-railway/add", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateAirportRailway = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/airport-railway/update", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useMasterAirport = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/airport-railway/master-airport", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useGetAirportData = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/airport-railway/get-airport-data", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/airport-railway/update-status", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAjaxAirportList = (params: any) => {
  return useQuery({
    queryKey: ["get-ajax-airport-list", params],
    queryFn: async () => {
      const queryParams = new URLSearchParams();

      if (params.airport_railway_name) {
        queryParams.append("airport_railway_name", params.airport_railway_name);
      }

      if (params.pickup_type) {
        queryParams.append("pickup_type", params.pickup_type);
      }

      const url = `airport-railway/get-ajax-airport-list${queryParams.toString() ? `?${queryParams.toString()}` : ""
        }`;

      const res = await api.get(url);
      console.log("ajax response", res.data);
      return res.data;
    },
  });
};

export const useGetAirportDataList = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/airport-railway/get-airport-data-list",
        payload
      );
      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateAirportDisplayOrder = () => {
  return useMutation({
    mutationFn: async (body: {
      city_id: number;
      id1: number;
      id2: number;
      user_id: number | undefined;
    }) => {
      const res = await api.put("/airport-railway/display-order/update", body);
      return res.data;
    },

    onError: (err: any) => {
      console.error(
        "Error swapping display order:",
        err?.response?.data || err
      );
    },
  });
};

// export const useUpdateAirportDisplayOrder = () => {
//   return useMutation({
//     mutationFn: async (body: {
//       city_id: number;
//       id: number[];
//       display_order: number[];
//     }) => {
//       const res = await api.put(
//         "/airport-railway/display-order/update",
//         body
//       );
//       return res.data;
//     },

//     onError: (err: any) => {
//       console.error("Error updating display order:", err?.response?.data || err);
//     },
//   });
// };

// coupan type

export const useAddCoupanType = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/coupan/coupan-type/add", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateCouponType = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/coupan/coupan-type/update-coupon-type",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useGetAllCoupanTypes = () => {
  return useQuery({
    queryKey: ["coupan-type"],
    queryFn: async () => {
      const res = await api.get("/coupan/coupan-type/all");
      console.log(res.data);
      return res.data;
    },
  });
};

// coupans
export const useCouponValidate = () => {
  return useQuery({
    queryKey: ["coupan-validate"],
    queryFn: async () => {
      const res = await api.get("/coupan/coupon-validate");
      console.log(res.data);
      return res.data;
    },
  });
};

export const useCouponValidation = () => {
  return useQuery({
    queryKey: ["coupon-validation"],
    queryFn: async () => {
      const res = await api.get("/coupan/coupon-validation");
      console.log(res.data);
      return res.data;
    },
  });
};

export const useAddCoupan = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/coupan/add-coupon", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useGetCoupons = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/coupan/get-coupons", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateCoupon = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/coupan/update-coupon", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useCouponImageUpload = (
  onSuccessCallback?: (filePath: string, url: string) => void,
  onErrorCallback?: (error: any) => void
) => {
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append("thumb_image", file);

      // Add folder as query parameter
      const res = await api.post(
        "/transfer/upload-image?folder=coupon",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status === "success") {
        // Return both filePath and url from response
        return {
          filePath: res.data.data.filePath,
          url: res.data.data.url,
        };
      } else {
        throw new Error(res.data.message || "Failed to upload image");
      }
    },
    onSuccess: (data) => {
      console.log(" Image upload successful:", data);
      if (onSuccessCallback) {
        onSuccessCallback(data.filePath, data.url);
      }
    },
    onError: (error: any) => {
      console.error(" Image upload failed:", error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    },
  });
};

export const useDeleteCouponTypes = (onSuccessCallback?: () => void) => {
  return useMutation({
    mutationFn: async (body: { id: string | number }) => {
      const res = await api.delete("/coupan/coupan-type/delete", {
        data: body,
      });
      console.log(res.data);
      return res?.data;
    },
    onSuccess: () => {
      if (onSuccessCallback) onSuccessCallback();
    },
  });
};

export const useDeleteCoupon = (onSuccessCallback?: () => void) => {
  return useMutation({
    mutationFn: async (body: { id: string | number }) => {
      const res = await api.delete("/coupan/delete", {
        data: body,
      });

      return res?.data;
    },
    onSuccess: () => {
      if (onSuccessCallback) onSuccessCallback();
    },
  });
};

// master booking types

export const useGetBookingTypes = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/booking-type/get-booking-types", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddBookingType = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/booking-type/add-booking-type", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateBookingType = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/booking-type/update-booking-type", payload);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateBookingTypeStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/booking-type/update-booking-type-status",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useDeleteBookingTypes = (onSuccessCallback?: () => void) => {
  return useMutation({
    mutationFn: async (body: { id: string | number }) => {
      const res = await api.delete("/booking-type/delete-booking-types", {
        data: body,
      });

      return res?.data;
    },
    onSuccess: () => {
      if (onSuccessCallback) onSuccessCallback();
    },
  });
};

export const useGetAllPackages = () => {
  return useQuery({
    queryKey: ["packages"],
    queryFn: async () => {
      const res = await api.get("/packages");
      console.log(res.data);
      return res.data;
    },
  });
};

// master Itineary Description

export const useGetItineraryDescriptionDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/itinerary-description/get-itinerary-description-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useAddItineraryDescriptionDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/itinerary-description/add-itinerary-description-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useUpdateItineraryDescriptionDetails = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post(
        "/itinerary-description/update-itinerary-description-details",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useItineraryDescriptionStatus = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put(
        "/itinerary-description/itinerary-description-status",
        payload
      );
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
};

export const useItinearyImageUpload = (
  onSuccessCallback?: (filePath: string, url: string) => void,
  onErrorCallback?: (error: any) => void
) => {
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append("thumb_image", file);

      // Add folder as query parameter
      const res = await api.post(
        "/transfer/upload-image?folder=itinary_description",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status === "success") {
        // Return both filePath and url from response
        return {
          filePath: res.data.data.filePath,
          url: res.data.data.url,
        };
      } else {
        throw new Error(res.data.message || "Failed to upload image");
      }
    },
    onSuccess: (data) => {
      console.log(" Image upload successful:", data);
      if (onSuccessCallback) {
        onSuccessCallback(data.filePath, data.url);
      }
    },
    onError: (error: any) => {
      console.error(" Image upload failed:", error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    },
  });
};

// dashboard

export const getCountryUserPercentage = (country_name: string) => {
  return useQuery({
    queryKey: ["country-by-user", country_name],
    queryFn: async () => {
      const res = await api.get(
        `/dashboard/country-percentage?country_name=${country_name}`
      );
      return res?.data;
    },
    enabled: !!country_name,
  });
};


interface UseCityCountryPercentageOptions {
  limit?: number;
  country_name?: string;
}

export const useCityCountryPercentage = (options: UseCityCountryPercentageOptions = {}) => {
  const { limit = 5, country_name, ...queryOptions } = options;

  return useQuery({
    queryKey: ["top-cities", limit, country_name],
    queryFn: async () => {
      try {
        // Build query parameters
        const params = new URLSearchParams();

        if (limit) params.append("limit", limit.toString());
        if (country_name) params.append("country_name", country_name);

        const queryString = params.toString();
        const url = `/dashboard/top-booking-cities${queryString ? `?${queryString}` : ''}`;

        const response = await api.get(url);

        if (!response.data.success) {
          throw new Error(response.data.message || "Failed to fetch city data");
        }

        return response.data;
      } catch (error) {
        console.error("Error fetching city data:", error);
        throw error;
      }
    },
    // Add default options for better UX
    retry: 2,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...queryOptions,
  });
};



// sightseeing starts here 

export const useSightSeeingLanguages = () => {
  return useQuery({
    queryKey: ["languages"],
    queryFn: async () => {
      const response = await api.get("/sightseeing-general/languages");
      return response.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

// get lanugages by s_id 
export const useSightSeeingLanguagesBySID = (s_id: string) => {
  return useQuery({
    queryKey: ["languages-by-sid", s_id],
    queryFn: async () => {
      const response = await api.get(`/sightseeing-general/languages/${s_id}`);
      return response.data;
    },
    enabled: !!s_id,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};


// get master tour theme tour category 

export const useMasterTourThemes = () => {
  return useQuery({
    queryKey: ["master-tour-themes"],
    queryFn: async () => {
      const response = await api.get("/sightseeing-general/theme-categories");
      return response.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};


// get master sightseeing type 

export const useMasterSightseeingTypes = () => {
  return useQuery({
    queryKey: ["master-sightseeing-types"],
    queryFn: async () => {
      const response = await api.get("/sightseeing-general/types");
      return response.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};


// get months list 
export const useMonthsList = () => {
  return useQuery({
    queryKey: ["months-list"],
    queryFn: async () => {
      const response = await api.get("/sightseeing-general/months");
      return response.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};


// get sightseeing name list 

export const useGetSightSeeingNameList = () => {
  return useQuery({
    queryKey: ["sightseeing-list"],
    queryFn: async () => {
      const res = await api.get("/sightseeing/sightseeings");
      return res.data;
    }
  })
}

export const useGetCityActivityList = () => {
  return useQuery({
    queryKey: ["city-activity-list"],
    queryFn: async () => {
      const res = await api.get("/activity/get-allCity-activities");
      return res.data;
    }
  })
}


export const useUpdateSightSeeingStatus = () => {
  return "hello"
}


// get terms and condition on s_id

export const useGetSightSeeingTermsAndCondition = (s_id: string) => {
  return useQuery({
    queryKey: ["terms", s_id],
    queryFn: async () => {
      const response = await api.get(`/sightseeing/terms/${s_id}`);
      return response.data;
    },
    enabled: !!s_id,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}


// update terms And condition 

export const useUpdateSightSeeingTermsAndCondition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/sightseeing/terms", payload);

      return res.data;
    },
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ["terms"] });
    },
    onError: (error) => {
      console.error('Error updating terms and conditions:', error);
    }
  })
}


// update Meta Info 

export const updateMetaInfo = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/sightseeing/meta", payload);
      return res.data;
    },
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ["sightseeing-list"] });
    },
    onError: (error) => {
      console.error('Error updating meta info:', error);
    }
  })
}


// get meta info with s_id 

export const useGetMetaInfo = (s_id: string) => {
  return useQuery({
    queryKey: ["meta-info", s_id],
    queryFn: async () => {
      const response = await api.get(`/sightseeing/meta/${s_id}`);
      return response.data;
    },
    enabled: !!s_id,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}


// get meeting points master 

export const useGetAllMasterMeetingPoints = () => {
  return useQuery({
    queryKey: ["master-meeting-points"],
    queryFn: async () => {
      const response = await api.get("/sightseeing-general/master-meeting-points");
      return response.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

// thing to carry 
export const useThingsNameList = () => {
  return useQuery({
    queryKey: ["things-name-list"],
    queryFn: async () => {
      const response = await api.get("/sightseeing-general/things");
      return response.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};


export const useUpdateGeneralDetail = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.put("/sightseeing-general/update", payload);
      return res.data;
    }
  })
}

export const useCreateSightseeingGeneral = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/sightseeing-general/create", payload);
      return res.data;
    }
  })
}



// sightseeing itinerarary add 

export const useCreateSightseeingItinerary = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/sightseeing_itinerary_city", payload);
      return res.data;
    }
  })
}

// sightseeing feature

export const useCreateSightseeingFeature = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/sightseeing_feature", payload);
      return res.data;
    }
  })
}



//sightseeing cancellation hooks

export const useGetCancellationFees = () => {
  return useQuery({
    queryKey: ["sightseeing-cancellation-fees"],
    queryFn: async () => {
      const res = await api.get("/sightseeing-cancellation");
      return res.data;
    }
  })
}


export const useAddCancellationFees = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/sightseeing-cancellation", payload);
      return res.data;
    }
  })
}


export const useGetSightseeingCancellationLogs = () => {
  return useQuery({
    queryKey: ["sightseeing-cancellation-logs"],
    queryFn: async () => {
      const res = await api.get("/sightseeing-cancellation/logs");
      return res.data;
    }
  })
}



// vendor name list 

export const useGetVendorNameList = () => {
  const { token } = useAuth();


  return useQuery({
    queryKey: ["vendor-list"],
    queryFn: async () => {
      const res = await api.get("/vendor/all", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    },
  });
}


// master meal type

export const useGetMasterMealType = () => {
  return useQuery({
    queryKey: ["meal-type"],
    queryFn: async () => {
      const res = await api.get("/meal-type");
      return res.data;
    },
  });
}


// master week days 

export const useGetAllWeekDays = () => {
  return useQuery({
    queryKey: ["master-week-days"],
    queryFn: async () => {
      const res = await api.get("/master-week-days");
      return res.data;
    }
  })
}

// get all currencies 


export const useGetAllCurrencies = () => {
  return useQuery({
    queryKey: ["currencies"],
    queryFn: async () => {
      const res = await api.get("/master-currency");
      return res.data;
    }
  })
}



export const useGetAssignedTo = () => {
  return useQuery({
    queryKey: ["assignedUser"],
    queryFn: async () => {
      const res = await api.get(`/user/newsletter-assigned-to-users`);
      // console.log(res?.data?.responseData?.response?.data);
      return res?.data?.responseData?.response?.data;
    },
    staleTime: 0,
  });
}





// Tour Type hooks
export const useGetActiveTourTypes = () => {
  return useQuery({
    queryKey: ["activeTourTypes"],
    queryFn: async () => {
      const res = await api.get("/tour-type/get-active-tour-types");
      // Handle different response structures
      if (res?.data?.status === 'success' && res?.data?.data) {
        return res.data.data;
      }
      if (res?.data?.responseData?.response?.data) {
        return res.data.responseData.response.data;
      }
      if (Array.isArray(res?.data)) {
        return res.data;
      }
      return [];
    },
    enabled: true,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  })
};

export const useGetNewsletterDuplicates = (payload: any) => {
  return useQuery({
    queryKey: ["newsletter-duplicates", payload?.email, payload?.mobile],
    queryFn: async () => {
      const res = await api.post(
        "/newsletter/check-duplicates",
        payload
      );
      return res.data.duplicates;
    },
    enabled: !!payload?.email || !!payload?.mobile, // don't run without data
    staleTime: 0,
  });
};
export const useMergeDuplicateNewsletterUsers = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/newsletter/merge-duplicates", {
        ...body,
      }),
    onSuccess: (res) => {
      return true;
    },
  });
};


export const useSendNewsletterMails = () => {
  return useMutation({
    mutationFn: (body: any) =>
      api.post("/newsletter/send-mail", body),
    onSuccess: (res) => {
      return true;
    }
  })
}

export const useCompanyUpdateLogo = (id: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ file, folder }: { file: File; folder: string }) => {
      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post(
        `/company/${id}/photo?folder=${encodeURIComponent(folder)}`,
        formData
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["company", id] });
    },
  });
};

export const useAddUserVehicleRegistrationMutation = () => {
  return useMutation({
    mutationFn: async (body: addCabForm) => {
      const res = await api.put('/vehicle/vehicle-type/add-user-vehicle-registration', body);
      return res?.data?.responseData?.response;
    }
  });
}

export const driverDutyInfo = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/user/add-duty-detail", payload);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    }
  });
};

export const useGetMasterWorkingShift = () => {
  return useQuery({
    queryKey: ["masterWorkingShift"],
    queryFn: async () => {
      const res = await api.get(`master-working-shift/`);
      return res?.data?.shifts;
    }
  })
}

export const useGetPackages = () => {
  return useQuery({
    queryKey: ["packages"],
    queryFn: async () => {
      const res = await api.get(`/packages/`);
      return res?.data?.data;
    }
  })
}

export const useGetCityActivitiesByCityId = (cityId: string) => {
  return useMutation({
    mutationFn: async () => {
      const res = await api.get(`/activity/get-city-activities/${cityId}`);
      console.log(res.data);

      return res.data;
    },
    onError: (err) => {
      console.error("error", err);
    },
  });
}

export const driverDutyInfoRegistration = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await api.post("/user/add-duty-detail-registration", payload);
      return res?.data?.responseData?.response?.data;
    },
    onError: (error: Error) => {
      return error?.message;
    }
  });
};




export const useSendOtp = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const response = await api.post('/auth/send-otp', body);
      console.log(response);
      return response.data;
    },
    onError: (error: Error) => {
      return error?.message;
    }
  });
};

export const useGetPANNumberVerificationMutation = () => {
  return useMutation({
    mutationFn: (pan: string) =>
      api.post('/user/pan-verification', { pan }),
    onSuccess: (res) => {
      const data = res?.data?.responseData?.response?.data;
      return data;
    },
    onError: (err) => {
      console.error(MESSAGES.FAILED_FETCHED, err);
    }
  })
}



export const useResendOtp = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/auth/resend-otp", body);
      return res.data;
    },
  });
};

export const useAssignSalesUserMutation = () => {
  return useMutation({
    mutationFn: async (body: any) => {
      const res = await api.post("/assigned-sales-user/", body,);
      console.log(res?.data);
      return res?.data;
    },
  });
};
